function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1000,
    height: 1000,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h1000v1000H0z",
    style: {
      strokeWidth: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffe000",
    d: "M0 0h500v1000H0z",
    style: {
      fill: "#fff200",
      strokeWidth: 0.4
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      strokeWidth: 1.875
    },
    transform: "rotate(51.428 1655.713 -1550.125)scale(.4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6741.5 539.99a16.12 16.12 0 0 0-16.12 16.115 16.12 16.12 0 0 0 7.34 13.512 21.3 21.3 0 0 1 8.778-1.9 21.3 21.3 0 0 1 8.775 1.904 16.12 16.12 0 0 0 7.344-13.513 16.12 16.12 0 0 0-16.117-16.118z",
    style: {
      InkscapeStroke: "none",
      fillRule: "evenodd",
      fill: "#bdbec0",
      fontVariationSettings: "normal",
      paintOrder: "markers fill stroke",
      stopColor: "#000",
      strokeDashoffset: 1.6197,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 1.875,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6741.5 567.71c-12.22 0-19.751 9.52-19.751 21.268 0 1.965.261 5.13.763 7.019 5.263-3.254 10.555-5.494 18.986-5.506 8.138 0 14.376 2.21 18.991 5.55.498-1.88.753-5.105.757-7.059 0-11.747-7.6-21.272-19.746-21.272z",
    style: {
      InkscapeStroke: "none",
      fillRule: "evenodd",
      fill: "#ffd500",
      fontVariationSettings: "normal",
      paintOrder: "markers fill stroke",
      stopColor: "#000",
      strokeDashoffset: 1.6197,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 1.875,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6741.5 590.49c-13.888-.002-25.147 7.217-25.147 16.124.019 3.18 1.502 6.284 4.264 8.925 3.77-7.503 11.915-12.392 20.882-12.408 8.97.004 17.236 4.885 21.018 12.387 2.745-2.635 4.108-5.73 4.127-8.898 0-8.906-11.257-16.128-25.144-16.129z",
    style: {
      InkscapeStroke: "none",
      fillRule: "evenodd",
      fill: "#bdbec0",
      fontVariationSettings: "normal",
      paintOrder: "markers fill stroke",
      stopColor: "#000",
      strokeDashoffset: 1.6197,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 1.875,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6741.6 603.13c-11.63.06-21.554 8.137-22.92 18.797 5.12-.793 14.698-1.03 22.925-1.029 8.496.001 18.169.315 22.888 1.001-1.368-10.669-11.253-18.722-22.894-18.77z",
    style: {
      InkscapeStroke: "none",
      fillRule: "evenodd",
      fill: "#ffd500",
      fontVariationSettings: "normal",
      paintOrder: "markers fill stroke",
      stopColor: "#000",
      strokeDashoffset: 1.6197,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 1.875,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6741.6 634.34c-8.325 0-18.403-.213-22.881 4.727l.049 17.783c6.089 22.923 12.692 36.166 22.822 50.156 11.192-15.45 18.127-29.34 24.766-57.148 3.469-16.034-12.555-15.516-24.756-15.518zm-22.695 71.27.186 67.275c4.246-11.185 8.49-22.365 11.846-33.389-3.402-11.183-7.726-22.54-12.031-33.887zm45.332.107c-4.295 11.313-8.599 22.63-11.992 33.78 3.32 10.912 7.508 21.983 11.709 33.056zm-22.646 66.27c-9.88 13.638-16.404 26.623-22.373 48.477l.049 19.238c4.55 4.772 14.081 4.941 22.314 4.942 12.201 0 28.222.527 24.756-15.508-6.633-27.811-13.557-41.697-24.746-57.148zm-22.178 85.166.108 41.152c5.441-3.96 13.485-6.257 21.982-6.27 8.484.004 16.538 2.287 21.992 6.231l.107-41.094c-5.83.705-13.086.92-22.022.918-9.005 0-16.316-.218-22.168-.937zm22.09 46.895c-6.982.011-13.47 2.684-17.539 7.1a17.4 17.4 0 0 0-1.592 1.992c-1.603 2.35-2.502 4.972-2.636 7.647-.055-.044-.112-.093-.166-.137l.214 89.746c6.325-1.566 13.742-2.481 21.71-2.48 7.967 0 15.384.923 21.708 2.49l.235-89.746-.117.097c-.484-9.337-10.112-16.707-21.816-16.709zm7.627 126.2v.01h.039c-.013 0-.026 0-.04-.01m-15.273.01c.18.51.395.997.635 1.465-.273-.546-.458-1.037-.625-1.465zm-9.55 1.221c.32.6.624 1.445.927 2.295-.358-1.036-.685-1.85-.928-2.295m34.374 0c-.476.871-1.218 2.85-1.904 5.371.548-1.96 1.164-3.556 1.904-5.37m-32.705 4.668c.08.282.16.561.235.85a53 53 0 0 0-.235-.85m37.09 28.34c-5.866 2.402-37.279 2.579-43.145.176v.01l.137 57.236c-9.052 24.03-20.61 55.643-24.463 71.035-6.47 25.844-2.963 66.074 15.693 86.846h60.362c18.66-20.77 22.188-60.99 15.723-86.836-3.851-15.393-15.405-47.012-24.453-71.045zm-20.693 127.47c7.155 4.132 13.827 17.765 12.393 34.316-1.636 18.888-5.11 34.366-18.35 34.365s-13.817-19.834-12.334-34.375c1.203-11.8 5.083-20.54 9.678-26.504 2.756-3.579 5.767-6.16 8.613-7.803z",
    style: {
      InkscapeStroke: "none",
      fillRule: "evenodd",
      fill: "#ffcc20",
      fontVariationSettings: "normal",
      paintOrder: "markers fill stroke",
      stopColor: "#000",
      strokeDashoffset: 1.6197,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 1.875,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6741.5 892.03a28.726 17.431.005 0 0-28.727 17.428 28.726 17.431.005 0 0 6.955 11.317 21.831 17.431.005 0 1 21.77-16.735 21.831 17.431.005 0 1 21.809 16.711 28.726 17.431.005 0 0 6.916-11.288 28.726 17.431.005 0 0-28.724-17.434zM6708.9 1279.8l65.16.01s10.275.001 10.274 13.697c0 13.696-10.276 13.695-10.276 13.695l-65.16-.01s-10.275.227-10.274-13.697c0-13.924 10.276-13.695 10.276-13.695",
    style: {
      InkscapeStroke: "none",
      fillRule: "evenodd",
      fill: "#bdbec0",
      fontVariationSettings: "normal",
      paintOrder: "markers fill stroke",
      stopColor: "#000",
      strokeDashoffset: 1.6197,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 1.875,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6704.8 1307.2 73.38.01s14.385 0 14.383 13.697c0 13.696-14.386 13.694-14.386 13.694l-73.38-.01s-14.385.227-14.384-13.697 14.386-13.694 14.386-13.694z",
    style: {
      InkscapeStroke: "none",
      fillRule: "evenodd",
      fill: "#bdbec0",
      fontVariationSettings: "normal",
      paintOrder: "markers fill stroke",
      stopColor: "#000",
      strokeDashoffset: 1.6197,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 1.875,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6741.5 1007.9c-22.963 0-41.579 7.5-41.58 16.755 0 .136.017.272.026.407.125-.101.265-.196.397-.295a12 12 0 0 1 1.006-.668c.197-.117.397-.233.608-.343a14 14 0 0 1 3.113-1.186l.21-.054c.408-.1.828-.194 1.267-.27v0h.016a21 21 0 0 1 1.64-.213c.457-.043.924-.078 1.412-.094.48-.016.99-.012 1.51 0 .201.01.402.015.61.028.135.01.269.014.406.026q.54.045 1.094.133c.1.016.198.039.297.056a14 14 0 0 1 1.31.297q.422.118.845.269c.122.043.242.079.364.126q.56.219 1.12.502c.608.307 1.212.673 1.81 1.114l.077.06a14 14 0 0 1 1.828 1.649l.044.049c.602.65 1.187 1.396 1.746 2.25 0 .01.01.01.011.013 0 .01.011.016.015.024.28.43.553.882.819 1.367q.401.73.778 1.55c0 .01.011.012.011.02 3.04-.561 6.25-.969 9.557-1.222a8.392 10.728.005 0 1-.762-4.409 8.392 10.728.005 0 1 8.393-10.726 8.392 10.728.005 0 1 8.391 10.727 8.392 10.728.005 0 1-.76 4.405 92 92 0 0 1 9.558 1.217 23 23 0 0 1 1.601-2.926l.036-.054a17 17 0 0 1 1.769-2.27 14 14 0 0 1 1.866-1.68q.015-.014.03-.025a12.6 12.6 0 0 1 1.833-1.127q.556-.281 1.111-.498c.133-.052.265-.092.398-.138a13 13 0 0 1 1.288-.384q.414-.098.823-.17c.107-.02.215-.043.32-.06q.552-.086 1.087-.13c.14-.013.275-.02.413-.029a21.083 21.083 0 0 1 2.115-.028c.49.017.96.051 1.421.095q.175.017.347.036a18.136 18.136 0 0 1 3.917.841c.729.248 1.386.543 1.999.864q.271.144.528.297.711.415 1.31.885c.044.035.096.067.138.103.015-.132.037-.255.038-.4 0-9.255-18.615-16.76-41.577-16.763z",
    style: {
      InkscapeStroke: "none",
      fillRule: "evenodd",
      fill: "#ffcc20",
      fontVariationSettings: "normal",
      paintOrder: "markers fill stroke",
      stopColor: "#000",
      strokeDashoffset: 1.6197,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 1.875,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6741.5 1015.1c-4.635 0-8.392 4.801-8.393 10.726.01 3.17 1.107 6.173 3.009 8.206-3.698 1.368-7.825 4.501-8.35 11.205-2.56-21.91-12.131-23.518-18.146-23.317s-9.762 2.479-11.588 5.184c-1.039 1.726-5.363 6.84.63 13.408 3.096-3.484 14.86 3.185 21.262 24.13 5.866 2.404 37.278 2.228 43.145-.174 3.545-32.68 14.38-28.34 17.476-24.855 5.994-6.568 5.46-10.774 4.422-12.5-1.826-2.706-5.571-4.984-11.587-5.187s-15.59 1.404-18.154 23.313c-.524-6.704-4.65-9.838-8.347-11.207 1.903-2.032 3.006-5.036 3.012-8.205 0-5.925-3.756-10.727-8.39-10.727z",
    style: {
      InkscapeStroke: "none",
      fillRule: "evenodd",
      fill: "#ffcc20",
      fontVariationSettings: "normal",
      paintOrder: "markers fill stroke",
      stopColor: "#000",
      strokeDashoffset: 1.6197,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 1.875,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6754.7 1226.3c-1.636 18.888-5.103 34.366-18.343 34.364-13.24 0-13.819-19.826-12.336-34.367 1.925-18.882 10.706-29.925 18.295-34.306 7.155 4.132 13.818 17.758 12.384 34.309",
    style: {
      InkscapeStroke: "none",
      fillRule: "evenodd",
      fill: "#a88d37",
      fontVariationSettings: "normal",
      stopColor: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 1.875,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6652.8 1375a117.3 117.3 0 0 0-28.658 76.811 117.3 117.3 0 0 0 117.29 117.31 117.3 117.3 0 0 0 117.31-117.29 117.3 117.3 0 0 0-117.29-117.31 117.3 117.3 0 0 0-88.652 40.477zm10.973 16.968a98.23 98.23 0 0 1 39.608-30.525c-7.474 8.747-12.011 20.078-12.012 32.485.028 2.877.304 5.746.825 8.576a50 50 0 0 0-8.637-.763c-12.407-.001-23.739 4.534-32.488 12.006a98.2 98.2 0 0 1 12.704-21.778zm2.284 34.971c7.174-8.691 18.031-14.23 30.18-14.229 2.261 0 4.517.203 6.743.597a39 39 0 0 1-.642-6.697c0-21.6 17.512-39.105 39.11-39.104 21.6 0 39.106 17.512 39.105 39.11a39 39 0 0 1-.655 6.758 39 39 0 0 1 6.757-.655c21.599 0 39.105 17.512 39.104 39.111 0 21.6-17.512 39.105-39.111 39.104a39 39 0 0 1-6.699-.644c.394 2.227.597 4.484.596 6.746 0 21.599-17.512 39.105-39.11 39.104-21.6 0-39.108-17.514-39.106-39.112.023-2.267.242-4.527.657-6.756a39 39 0 0 1-6.757.655c-21.599 0-39.105-17.512-39.104-39.111 0-9.45 3.353-18.116 8.933-24.876zm-14.996 62.945c8.747 7.474 20.079 12.009 32.486 12.011a50 50 0 0 0 8.653-.84 50 50 0 0 0-.842 8.653c0 12.407 4.534 23.74 12.006 32.488a98.23 98.23 0 0 1-52.304-52.312zm128.2-128.71a98.23 98.23 0 0 1 52.832 52.84c-8.785-7.62-20.22-12.263-32.761-12.264-2.903.029-5.799.31-8.653.84.53-2.854.812-5.75.842-8.653 0-12.542-4.642-23.976-12.26-32.762zm11.484 139.91a50 50 0 0 0 8.576.826c12.407 0 23.74-4.534 32.488-12.006a98.23 98.23 0 0 1-52.312 52.304c7.474-8.747 12.011-20.078 12.012-32.485 0-2.896-.26-5.787-.764-8.639z",
    style: {
      InkscapeStroke: "none",
      fillRule: "evenodd",
      fill: "#ffcc20",
      fontVariationSettings: "normal",
      paintOrder: "markers fill stroke",
      stopColor: "#000",
      strokeDashoffset: 1.6197,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 1.875,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6590.2,
    cy: 1451.2,
    r: 18.08,
    style: {
      InkscapeStroke: "none",
      fillRule: "evenodd",
      fill: "#ffcc20",
      fontVariationSettings: "normal",
      paintOrder: "markers fill stroke",
      stopColor: "#000",
      strokeDashoffset: 1.6197,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 1.875,
      stroke: "#000"
    },
    transform: "rotate(.005)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6608.2 1435.2s0-8.22 7.99-8.22c7.99.002 7.99 8.222 7.99 8.222v33.267s-.002 8.22-7.991 8.219c-7.99-.001-7.99-8.221-7.99-8.221z",
    style: {
      InkscapeStroke: "none",
      fillRule: "evenodd",
      fill: "#ffcc20",
      fontVariationSettings: "normal",
      paintOrder: "markers fill stroke",
      stopColor: "#000",
      strokeDashoffset: 1.6197,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 1.875,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6741.5 1334.6c64.777.013 117.28 52.533 117.27 117.31s-52.519 117.29-117.3 117.29c95.428.01 140.2-52.504 140.21-117.29.01-64.782-44.779-117.3-140.19-117.31z",
    style: {
      InkscapeStroke: "none",
      fillRule: "evenodd",
      fill: "#a88d37",
      fontVariationSettings: "normal",
      stopColor: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 1.875,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6779.3 1361.2c7.618 8.786 12.26 20.222 12.258 32.764a50 50 0 0 1-.842 8.653c2.855-.53 5.75-.811 8.654-.84 12.542 0 23.977 4.645 32.762 12.265a98.23 98.23 0 0 0-52.832-52.842zm-75.885.27a98.23 98.23 0 0 0-52.312 52.302c8.749-7.472 20.08-12.007 32.487-12.006 2.896.01 5.786.26 8.637.765-.52-2.83-.796-5.7-.824-8.577 0-12.407 4.538-23.738 12.012-32.485zm-52.319 128.44a98.23 98.23 0 0 0 52.302 52.312c-7.472-8.749-12.007-20.08-12.006-32.487a50 50 0 0 1 .842-8.653c-2.855.53-5.75.811-8.654.84-12.407 0-23.738-4.539-32.485-12.012zm180.75.017c-8.749 7.472-20.08 12.007-32.487 12.006a50 50 0 0 1-8.577-.826c.504 2.852.764 5.742.764 8.638 0 12.407-4.538 23.738-12.012 32.485a98.23 98.23 0 0 0 52.312-52.302z",
    style: {
      InkscapeStroke: "none",
      fillRule: "evenodd",
      fill: "#a88d37",
      fontVariationSettings: "normal",
      stopColor: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 1.875,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -1602.6,
    cy: 6741.6,
    r: 18.08,
    style: {
      InkscapeStroke: "none",
      fillRule: "evenodd",
      fill: "#ffcc20",
      fontVariationSettings: "normal",
      paintOrder: "markers fill stroke",
      stopColor: "#000",
      strokeDashoffset: 1.6197,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 1.875,
      stroke: "#000"
    },
    transform: "rotate(-89.995)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6724.8 1585.1s-8.22 0-8.22-7.99c.002-7.99 8.221-7.99 8.221-7.99h33.267s8.22.002 8.22 7.991c-.001 7.99-8.221 7.99-8.221 7.99z",
    style: {
      InkscapeStroke: "none",
      fillRule: "evenodd",
      fill: "#ffcc20",
      fontVariationSettings: "normal",
      paintOrder: "markers fill stroke",
      stopColor: "#000",
      strokeDashoffset: 1.6197,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 1.875,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -6896.5,
    cy: -1451.2,
    r: 18.08,
    style: {
      InkscapeStroke: "none",
      fillRule: "evenodd",
      fill: "#ffcc20",
      fontVariationSettings: "normal",
      paintOrder: "markers fill stroke",
      stopColor: "#000",
      strokeDashoffset: 1.6197,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 1.875,
      stroke: "#000"
    },
    transform: "rotate(180.01)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6878.3 1468.5s0 8.22-7.99 8.22c-7.99-.002-7.99-8.221-7.99-8.221v-33.268s.002-8.22 7.991-8.219c7.99.001 7.99 8.221 7.99 8.221zM6778.6 663.07c-3.581 13.998-8.991 28.333-14.429 42.666l-.278 66.804c3.838 10.117 7.614 20.227 10.827 30.232 16.763 12.496 29.146 24.544 39.063 41.046l37.829.916.778-17.891 22.408-3.477-.975 20.644 22.828-3.141 7.449-7.712.695-69.457-9.406 7.425-52.66-1.163.812 17.073 12.622 8.842-.391 10.405-54.644 1.938-.838-13.547 12.168-2.525 3.495-17.398-15.34-1.454-11.776 15.079-9.22.392-.288-51.543 10.196.074 9.465 10.733 13.398-.12-3.8-16.082-7.944-.39.124-16.602 47.454.548 2.05 12.215-8.978 6.542 1.043 13.697 50.698-4.523 8.005-6.231-3.417-69.44-25.738-.79.512 19.657-20.768.026-1.567-20.573-42.206-1.709-.16 24.916-21.248.143.514-25.908z",
    style: {
      InkscapeStroke: "none",
      fillRule: "evenodd",
      fill: "#ffcc20",
      fontVariationSettings: "normal",
      paintOrder: "markers fill stroke",
      stopColor: "#000",
      strokeDashoffset: 1.6197,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 1.875,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6787 663.41-.52 25.916 21.25-.153.068-10.495zM6850.1 665.97l1.564 20.57 20.772-.026-.084-3.238zM6897.7 667.65l3.423 69.436-8.009 6.236-50.696 4.517 18.837 16.348 52.3-4.41 8.412-6.037-3.83-69.725z",
    style: {
      InkscapeStroke: "none",
      fillRule: "evenodd",
      fill: "#a88d37",
      fontVariationSettings: "normal",
      paintOrder: "markers fill stroke",
      stopColor: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 1.875,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6901.1 737.09 20.844 16.651M6893.1 743.32l20.434 16.457",
    style: {
      InkscapeStroke: "none",
      fill: "none",
      fontVariationSettings: "normal",
      paintOrder: "markers fill stroke",
      stopColor: "#000",
      strokeDashoffset: 1.6197,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 1.875,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6841.3 734.14 8.97-6.531-2.043-12.223-47.458-.548-.122 16.604 7.944.387 3.797 16.089-13.392.113-9.47-10.735-10.189-.068.288 51.541 9.207-.391 11.785-15.07-.768-17.155 7.99-.174 11.338 10.193 15.85.42-4.948-18.836-6.91-4.95-.337-9.738z",
    style: {
      InkscapeStroke: "none",
      fillRule: "evenodd",
      fill: "#a88d37",
      fontVariationSettings: "normal",
      paintOrder: "markers fill stroke",
      stopColor: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 1.875,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6819.2 766.17-20.181-18.142M6779.4 737.23l20.512 18.925M6812.4 747.92l22.638 18.676M6808.6 731.83l14.577 10.978",
    style: {
      InkscapeStroke: "none",
      fill: "none",
      fontVariationSettings: "normal",
      paintOrder: "markers fill stroke",
      stopColor: "#000",
      strokeDashoffset: 1.6197,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 1.875,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6833.5 807.08 3.22-15.095-20.734-17.226-3.498 17.395-12.164 2.527.835 13.542z",
    style: {
      InkscapeStroke: "none",
      fillRule: "evenodd",
      fill: "#a88d37",
      fontVariationSettings: "normal",
      paintOrder: "markers fill stroke",
      stopColor: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 1.875,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6812.5 792.15 18.312 15.021",
    style: {
      InkscapeStroke: "none",
      fill: "none",
      fontVariationSettings: "normal",
      paintOrder: "markers fill stroke",
      stopColor: "#000",
      strokeDashoffset: 1.6197,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 1.875,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6813.8 843.82c3.176 5.285 6.139 11.085 8.839 17.516l50.459.021.742-17.345.974-20.658-22.413 3.498-.774 17.87z",
    style: {
      InkscapeStroke: "none",
      fillRule: "evenodd",
      fill: "#a88d37",
      fontVariationSettings: "normal",
      paintOrder: "markers fill stroke",
      stopColor: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 1.875,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6851.7 844.73 21.471 16.635M6852.4 826.85l42.375 35.741",
    style: {
      InkscapeStroke: "none",
      fill: "none",
      fontVariationSettings: "normal",
      paintOrder: "markers fill stroke",
      stopColor: "#000",
      strokeDashoffset: 1.6197,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 1.875,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6873.9 844.02-.038.88 20.977 17.694 22.431-4.33 7.741-8.384.096-69.585-20.235-16.588-.69 69.46-7.457 7.704z",
    style: {
      InkscapeStroke: "none",
      fillRule: "evenodd",
      fill: "#a88d37",
      fontVariationSettings: "normal",
      paintOrder: "markers fill stroke",
      stopColor: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 1.875,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6896.7 840.87 20.546 17.393M6904.2 833.16l20.83 16.713",
    style: {
      InkscapeStroke: "none",
      fill: "none",
      fontVariationSettings: "normal",
      paintOrder: "markers fill stroke",
      stopColor: "#000",
      strokeDashoffset: 1.6197,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 1.875,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6741.6 620.9c-9.488 0-16.931.288-22.93 1.104l.049 17.295c4.416-5.078 14.481-4.962 22.881-4.961 12.201 0 28.225-.517 24.756 15.518-6.639 27.81-13.574 41.699-24.766 57.148-10.131-13.991-16.734-27.234-22.822-50.156l.137 48.643c4.32 11.389 8.617 22.779 12.03 34.004-3.363 11.05-7.588 22.254-11.845 33.467l.127 47.5c5.968-21.854 12.494-34.84 22.373-48.477 11.189 15.452 18.113 29.337 24.746 57.148 3.465 16.035-12.555 15.509-24.756 15.508-8.035-.001-17.614.128-22.305-4.297l.039 16.719c5.893.745 13.128 1.024 22.266 1.025 30.248.003 41.72-2.29 41.055-18.682-2.056-31.847-20.261-66.608-30.391-99.912 10.136-33.303 28.348-68.066 30.41-99.912.668-16.39-10.807-18.679-41.055-18.682z",
    style: {
      InkscapeStroke: "none",
      fillRule: "evenodd",
      fill: "#bdbec0",
      fontVariationSettings: "normal",
      paintOrder: "markers fill stroke",
      stopColor: "#000",
      strokeDashoffset: 1.6197,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 1.875,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6727.7 1045.3c.525-6.704 4.651-9.838 8.349-11.206-.978-1.045-1.737-2.349-2.25-3.797-3.306.253-6.517.66-9.555 1.221.876 1.605 2.838 7.663 3.456 13.782m21.37-15.003c-.515 1.45-1.28 2.754-2.258 3.799 3.697 1.368 7.823 4.502 8.347 11.206.538-6.004 2.519-12.067 3.46-13.79-3.36-.64-7.538-1.082-9.549-1.215",
    style: {
      InkscapeStroke: "none",
      fillRule: "evenodd",
      fill: "#a88d37",
      fontVariationSettings: "normal",
      paintOrder: "markers fill stroke",
      stopColor: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 1.875,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6742.4 1192 2.739-62.413",
    style: {
      InkscapeStroke: "none",
      fill: "none",
      fontVariationSettings: "normal",
      stopColor: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 1.875,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6703.7 1412.6a18.08 18.08 0 0 1 25.569 0 18.08 18.08 0 0 1 0 25.569 18.08 18.08 0 0 1-25.569 0 18.08 18.08 0 0 1 0-25.569M6754.4 1413.4a18.08 18.08 0 0 1 25.569 0 18.08 18.08 0 0 1 0 25.569 18.08 18.08 0 0 1-25.569 0 18.08 18.08 0 0 1 0-25.569M6755.1 1464a18.08 18.08 0 0 1 25.569 0 18.08 18.08 0 0 1 0 25.569 18.08 18.08 0 0 1-25.569 0 18.08 18.08 0 0 1 0-25.569M6702.9 1464.8a18.08 18.08 0 0 1 25.569 0 18.08 18.08 0 0 1 0 25.569 18.08 18.08 0 0 1-25.569 0 18.08 18.08 0 0 1 0-25.569",
    style: {
      InkscapeStroke: "none",
      fillRule: "evenodd",
      fill: "#ffcc20",
      fontVariationSettings: "normal",
      paintOrder: "markers fill stroke",
      stopColor: "#000",
      strokeDashoffset: 1.6197,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 1.875,
      stroke: "#000"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      strokeWidth: 1.875
    },
    transform: "scale(-.4 .4)rotate(51.428 2268.716 -7759.632)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6741.5 539.99a16.12 16.12 0 0 0-16.12 16.115 16.12 16.12 0 0 0 7.34 13.512 21.3 21.3 0 0 1 8.778-1.9 21.3 21.3 0 0 1 8.775 1.904 16.12 16.12 0 0 0 7.344-13.513 16.12 16.12 0 0 0-16.117-16.118z",
    style: {
      InkscapeStroke: "none",
      fillRule: "evenodd",
      fill: "#ffcc20",
      fontVariationSettings: "normal",
      paintOrder: "markers fill stroke",
      stopColor: "#000",
      strokeDashoffset: 1.6197,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 1.875,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6741.5 567.71c-12.22 0-19.751 9.52-19.751 21.268 0 1.965.261 5.13.763 7.019 5.263-3.254 10.555-5.494 18.986-5.506 8.138 0 14.376 2.21 18.991 5.55.498-1.88.753-5.105.757-7.059 0-11.747-7.6-21.272-19.746-21.272z",
    style: {
      InkscapeStroke: "none",
      fillRule: "evenodd",
      fill: "#bdbec0",
      fontVariationSettings: "normal",
      paintOrder: "markers fill stroke",
      stopColor: "#000",
      strokeDashoffset: 1.6197,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 1.875,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6741.5 590.49c-13.888-.002-25.147 7.217-25.147 16.124.019 3.18 1.502 6.284 4.264 8.925 3.77-7.503 11.915-12.392 20.882-12.408 8.97.004 17.236 4.885 21.018 12.387 2.745-2.635 4.108-5.73 4.127-8.898 0-8.906-11.257-16.128-25.144-16.129z",
    style: {
      InkscapeStroke: "none",
      fillRule: "evenodd",
      fill: "#ffcc20",
      fontVariationSettings: "normal",
      paintOrder: "markers fill stroke",
      stopColor: "#000",
      strokeDashoffset: 1.6197,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 1.875,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6741.6 603.13c-11.63.06-21.554 8.137-22.92 18.797 5.12-.793 14.698-1.03 22.925-1.029 8.496.001 18.169.315 22.888 1.001-1.368-10.669-11.253-18.722-22.894-18.77zM6741.6 634.34c-8.325 0-18.403-.213-22.881 4.727l.049 17.783c6.089 22.923 12.692 36.166 22.822 50.156 11.192-15.45 18.127-29.34 24.766-57.148 3.469-16.034-12.555-15.516-24.756-15.518zm-22.695 71.27.186 67.275c4.246-11.185 8.49-22.365 11.846-33.389-3.402-11.183-7.726-22.54-12.031-33.887zm45.332.107c-4.295 11.313-8.599 22.63-11.992 33.78 3.32 10.912 7.508 21.983 11.709 33.056zm-22.646 66.27c-9.88 13.638-16.404 26.623-22.373 48.477l.049 19.238c4.55 4.772 14.081 4.941 22.314 4.942 12.201 0 28.222.527 24.756-15.508-6.633-27.811-13.557-41.697-24.746-57.148zm-22.178 85.166.108 41.152c5.441-3.96 13.485-6.257 21.982-6.27 8.484.004 16.538 2.287 21.992 6.231l.107-41.094c-5.83.705-13.086.92-22.022.918-9.005 0-16.316-.218-22.168-.937zm22.09 46.895c-6.982.011-13.47 2.684-17.539 7.1a17.4 17.4 0 0 0-1.592 1.992c-1.603 2.35-2.502 4.972-2.636 7.647-.055-.044-.112-.093-.166-.137l.214 89.746c6.325-1.566 13.742-2.481 21.71-2.48 7.967 0 15.384.923 21.708 2.49l.235-89.746-.117.097c-.484-9.337-10.112-16.707-21.816-16.709zm7.627 126.2v.01h.039c-.013 0-.026 0-.04-.01m-15.273.01c.18.51.395.997.635 1.465-.273-.546-.458-1.037-.625-1.465zm-9.55 1.221c.32.6.624 1.445.927 2.295-.358-1.036-.685-1.85-.928-2.295m34.374 0c-.476.871-1.218 2.85-1.904 5.371.548-1.96 1.164-3.556 1.904-5.37m-32.705 4.668c.08.282.16.561.235.85a53 53 0 0 0-.235-.85m37.09 28.34c-5.866 2.402-37.279 2.579-43.145.176v.01l.137 57.236c-9.052 24.03-20.61 55.643-24.463 71.035-6.47 25.844-2.963 66.074 15.693 86.846h60.361999999999995c18.66-20.77 22.188-60.99 15.723-86.836-3.851-15.393-15.405-47.012-24.453-71.045zm-20.693 127.47c7.155 4.132 13.827 17.765 12.393 34.316-1.636 18.888-5.11 34.366-18.35 34.365s-13.817-19.834-12.334-34.375c1.203-11.8 5.083-20.54 9.678-26.504 2.756-3.579 5.767-6.16 8.613-7.803z",
    style: {
      InkscapeStroke: "none",
      fillRule: "evenodd",
      fill: "#bdbec0",
      fontVariationSettings: "normal",
      paintOrder: "markers fill stroke",
      stopColor: "#000",
      strokeDashoffset: 1.6197,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 1.875,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6741.5 892.03a28.726 17.431.005 0 0-28.727 17.428 28.726 17.431.005 0 0 6.955 11.317 21.831 17.431.005 0 1 21.77-16.735 21.831 17.431.005 0 1 21.809 16.711 28.726 17.431.005 0 0 6.916-11.288 28.726 17.431.005 0 0-28.724-17.434zM6708.9 1279.8l65.16.01s10.275.001 10.274 13.697c0 13.696-10.276 13.695-10.276 13.695l-65.16-.01s-10.275.227-10.274-13.697c0-13.924 10.276-13.695 10.276-13.695",
    style: {
      InkscapeStroke: "none",
      fillRule: "evenodd",
      fill: "#ffcc20",
      fontVariationSettings: "normal",
      paintOrder: "markers fill stroke",
      stopColor: "#000",
      strokeDashoffset: 1.6197,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 1.875,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6704.8 1307.2 73.38.01s14.385 0 14.383 13.697c0 13.696-14.386 13.694-14.386 13.694l-73.38-.01s-14.385.227-14.384-13.697 14.386-13.694 14.386-13.694z",
    style: {
      InkscapeStroke: "none",
      fillRule: "evenodd",
      fill: "#ffcc20",
      fontVariationSettings: "normal",
      paintOrder: "markers fill stroke",
      stopColor: "#000",
      strokeDashoffset: 1.6197,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 1.875,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6741.5 1007.9c-22.963 0-41.579 7.5-41.58 16.755 0 .136.017.272.026.407.125-.101.265-.196.397-.295a12 12 0 0 1 1.006-.668c.197-.117.397-.233.608-.343a14 14 0 0 1 3.113-1.186l.21-.054c.408-.1.828-.194 1.267-.27v0h.016a21 21 0 0 1 1.64-.213c.457-.043.924-.078 1.412-.094.48-.016.99-.012 1.51 0 .201.01.402.015.61.028.135.01.269.014.406.026q.54.045 1.094.133c.1.016.198.039.297.056a14 14 0 0 1 1.31.297q.422.118.845.269c.122.043.242.079.364.126q.56.219 1.12.502c.608.307 1.212.673 1.81 1.114l.077.06a14 14 0 0 1 1.828 1.649l.044.049c.602.65 1.187 1.396 1.746 2.25 0 .01.01.01.011.013 0 .01.011.016.015.024.28.43.553.882.819 1.367q.401.73.778 1.55c0 .01.011.012.011.02 3.04-.561 6.25-.969 9.557-1.222a8.392 10.728.005 0 1-.762-4.409 8.392 10.728.005 0 1 8.393-10.726 8.392 10.728.005 0 1 8.391 10.727 8.392 10.728.005 0 1-.76 4.405 92 92 0 0 1 9.558 1.217 23 23 0 0 1 1.601-2.926l.036-.054a17 17 0 0 1 1.769-2.27 14 14 0 0 1 1.866-1.68q.015-.014.03-.025a12.6 12.6 0 0 1 1.833-1.127q.556-.281 1.111-.498c.133-.052.265-.092.398-.138a13 13 0 0 1 1.288-.384q.414-.098.823-.17c.107-.02.215-.043.32-.06q.552-.086 1.087-.13c.14-.013.275-.02.413-.029a21.083 21.083 0 0 1 2.115-.028c.49.017.96.051 1.421.095q.175.017.347.036a18.136 18.136 0 0 1 3.917.841c.729.248 1.386.543 1.999.864q.271.144.528.297.711.415 1.31.885c.044.035.096.067.138.103.015-.132.037-.255.038-.4 0-9.255-18.615-16.76-41.577-16.763z",
    style: {
      InkscapeStroke: "none",
      fillRule: "evenodd",
      fill: "#bdbec0",
      fontVariationSettings: "normal",
      paintOrder: "markers fill stroke",
      stopColor: "#000",
      strokeDashoffset: 1.6197,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 1.875,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6741.5 1015.1c-4.635 0-8.392 4.801-8.393 10.726.01 3.17 1.107 6.173 3.009 8.206-3.698 1.368-7.825 4.501-8.35 11.205-2.56-21.91-12.131-23.518-18.146-23.317s-9.762 2.479-11.588 5.184c-1.039 1.726-5.363 6.84.63 13.408 3.096-3.484 14.86 3.185 21.262 24.13 5.866 2.404 37.278 2.228 43.145-.174 3.545-32.68 14.38-28.34 17.476-24.855 5.994-6.568 5.46-10.774 4.422-12.5-1.826-2.706-5.571-4.984-11.587-5.187s-15.59 1.404-18.154 23.313c-.524-6.704-4.65-9.838-8.347-11.207 1.903-2.032 3.006-5.036 3.012-8.205 0-5.925-3.756-10.727-8.39-10.727z",
    style: {
      InkscapeStroke: "none",
      fillRule: "evenodd",
      fill: "#bdbec0",
      fontVariationSettings: "normal",
      paintOrder: "markers fill stroke",
      stopColor: "#000",
      strokeDashoffset: 1.6197,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 1.875,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6754.7 1226.3c-1.636 18.888-5.103 34.366-18.343 34.364-13.24 0-13.819-19.826-12.336-34.367 1.925-18.882 10.706-29.925 18.295-34.306 7.155 4.132 13.818 17.758 12.384 34.309",
    style: {
      InkscapeStroke: "none",
      fillRule: "evenodd",
      fill: "#515356",
      fontVariationSettings: "normal",
      stopColor: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 1.875,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6652.8 1375a117.3 117.3 0 0 0-28.658 76.811 117.3 117.3 0 0 0 117.29 117.31 117.3 117.3 0 0 0 117.31-117.29 117.3 117.3 0 0 0-117.29-117.31 117.3 117.3 0 0 0-88.652 40.477zm10.973 16.968a98.23 98.23 0 0 1 39.608-30.525c-7.474 8.747-12.011 20.078-12.012 32.485.028 2.877.304 5.746.825 8.576a50 50 0 0 0-8.637-.763c-12.407-.001-23.739 4.534-32.488 12.006a98.2 98.2 0 0 1 12.704-21.778zm2.284 34.971c7.174-8.691 18.031-14.23 30.18-14.229 2.261 0 4.517.203 6.743.597a39 39 0 0 1-.642-6.697c0-21.6 17.512-39.105 39.11-39.104 21.6 0 39.106 17.512 39.105 39.11a39 39 0 0 1-.655 6.758 39 39 0 0 1 6.757-.655c21.599 0 39.105 17.512 39.104 39.111 0 21.6-17.512 39.105-39.111 39.104a39 39 0 0 1-6.699-.644c.394 2.227.597 4.484.596 6.746 0 21.599-17.512 39.105-39.11 39.104-21.6 0-39.108-17.514-39.106-39.112.023-2.267.242-4.527.657-6.756a39 39 0 0 1-6.757.655c-21.599 0-39.105-17.512-39.104-39.111 0-9.45 3.353-18.116 8.933-24.876zm-14.996 62.945c8.747 7.474 20.079 12.009 32.486 12.011a50 50 0 0 0 8.653-.84 50 50 0 0 0-.842 8.653c0 12.407 4.534 23.74 12.006 32.488a98.23 98.23 0 0 1-52.304-52.312zm128.2-128.71a98.23 98.23 0 0 1 52.832 52.84c-8.785-7.62-20.22-12.263-32.761-12.264-2.903.029-5.799.31-8.653.84.53-2.854.812-5.75.842-8.653 0-12.542-4.642-23.976-12.26-32.762zm11.484 139.91a50 50 0 0 0 8.576.826c12.407 0 23.74-4.534 32.488-12.006a98.23 98.23 0 0 1-52.312 52.304c7.474-8.747 12.011-20.078 12.012-32.485 0-2.896-.26-5.787-.764-8.639z",
    style: {
      InkscapeStroke: "none",
      fillRule: "evenodd",
      fill: "#bdbec0",
      fontVariationSettings: "normal",
      paintOrder: "markers fill stroke",
      stopColor: "#000",
      strokeDashoffset: 1.6197,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 1.875,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6590.2,
    cy: 1451.2,
    r: 18.08,
    style: {
      InkscapeStroke: "none",
      fillRule: "evenodd",
      fill: "#bdbec0",
      fontVariationSettings: "normal",
      paintOrder: "markers fill stroke",
      stopColor: "#000",
      strokeDashoffset: 1.6197,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 1.875,
      stroke: "#000"
    },
    transform: "rotate(.005)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6608.2 1435.2s0-8.22 7.99-8.22c7.99.002 7.99 8.222 7.99 8.222v33.267s-.002 8.22-7.991 8.219c-7.99-.001-7.99-8.221-7.99-8.221z",
    style: {
      InkscapeStroke: "none",
      fillRule: "evenodd",
      fill: "#bdbec0",
      fontVariationSettings: "normal",
      paintOrder: "markers fill stroke",
      stopColor: "#000",
      strokeDashoffset: 1.6197,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 1.875,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6741.5 1334.6c64.777.013 117.28 52.533 117.27 117.31s-52.519 117.29-117.3 117.29c95.428.01 140.2-52.504 140.21-117.29.01-64.782-44.779-117.3-140.19-117.31z",
    style: {
      InkscapeStroke: "none",
      fillRule: "evenodd",
      fill: "#515356",
      fontVariationSettings: "normal",
      stopColor: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 1.875,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6779.3 1361.2c7.618 8.786 12.26 20.222 12.258 32.764a50 50 0 0 1-.842 8.653c2.855-.53 5.75-.811 8.654-.84 12.542 0 23.977 4.645 32.762 12.265a98.23 98.23 0 0 0-52.832-52.842zm-75.885.27a98.23 98.23 0 0 0-52.312 52.302c8.749-7.472 20.08-12.007 32.487-12.006 2.896.01 5.786.26 8.637.765-.52-2.83-.796-5.7-.824-8.577 0-12.407 4.538-23.738 12.012-32.485zm-52.319 128.44a98.23 98.23 0 0 0 52.302 52.312c-7.472-8.749-12.007-20.08-12.006-32.487a50 50 0 0 1 .842-8.653c-2.855.53-5.75.811-8.654.84-12.407 0-23.738-4.539-32.485-12.012zm180.75.017c-8.749 7.472-20.08 12.007-32.487 12.006a50 50 0 0 1-8.577-.826c.504 2.852.764 5.742.764 8.638 0 12.407-4.538 23.738-12.012 32.485a98.23 98.23 0 0 0 52.312-52.302z",
    style: {
      InkscapeStroke: "none",
      fillRule: "evenodd",
      fill: "#515356",
      fontVariationSettings: "normal",
      stopColor: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 1.875,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -1602.6,
    cy: 6741.6,
    r: 18.08,
    style: {
      InkscapeStroke: "none",
      fillRule: "evenodd",
      fill: "#bdbec0",
      fontVariationSettings: "normal",
      paintOrder: "markers fill stroke",
      stopColor: "#000",
      strokeDashoffset: 1.6197,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 1.875,
      stroke: "#000"
    },
    transform: "rotate(-89.995)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6724.8 1585.1s-8.22 0-8.22-7.99c.002-7.99 8.221-7.99 8.221-7.99h33.267s8.22.002 8.22 7.991c-.001 7.99-8.221 7.99-8.221 7.99z",
    style: {
      InkscapeStroke: "none",
      fillRule: "evenodd",
      fill: "#bdbec0",
      fontVariationSettings: "normal",
      paintOrder: "markers fill stroke",
      stopColor: "#000",
      strokeDashoffset: 1.6197,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 1.875,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -6896.5,
    cy: -1451.2,
    r: 18.08,
    style: {
      InkscapeStroke: "none",
      fillRule: "evenodd",
      fill: "#bdbec0",
      fontVariationSettings: "normal",
      paintOrder: "markers fill stroke",
      stopColor: "#000",
      strokeDashoffset: 1.6197,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 1.875,
      stroke: "#000"
    },
    transform: "rotate(180.01)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6878.3 1468.5s0 8.22-7.99 8.22c-7.99-.002-7.99-8.221-7.99-8.221v-33.268s.002-8.22 7.991-8.219c7.99.001 7.99 8.221 7.99 8.221zM6778.6 663.07l8.363.337-.514 25.908 21.248-.143.166-24.924 42.2 1.716 1.567 20.573 20.768-.025-.512-19.657 25.738.79 3.417 69.44-8.005 6.231-50.698 4.523-1.043-13.697 8.978-6.543-2.044-12.222-47.46-.54-.124 16.602 7.945.39 3.799 16.083-13.398.12-9.465-10.733-10.196-.075.29 51.543 9.218-.392 11.776-15.079 15.34 1.455-3.495 17.398-12.168 2.524.838 13.547 54.644-1.938.391-10.405-12.622-8.841-.811-17.073 52.659 1.163 9.407-7.425-.696 69.457-7.449 7.711-22.828 3.142.975-20.644-22.408 3.476-.778 17.891-37.982-.912c-9.875-16.393-22.198-28.396-38.843-40.821-3.228-10.08-7.027-20.266-10.894-30.46l.278-66.804c5.438-14.333 10.847-28.668 14.43-42.666z",
    style: {
      InkscapeStroke: "none",
      fillRule: "evenodd",
      fill: "#bdbec0",
      fontVariationSettings: "normal",
      paintOrder: "markers fill stroke",
      stopColor: "#000",
      strokeDashoffset: 1.6197,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 1.875,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6787 663.41-.52 25.916 21.25-.153.068-10.495zM6850.1 665.97l1.564 20.57 20.772-.026-.084-3.238zM6897.7 667.65l3.423 69.436-8.009 6.236-50.696 4.517 18.837 16.348 52.3-4.41 8.412-6.037-3.83-69.725z",
    style: {
      InkscapeStroke: "none",
      fillRule: "evenodd",
      fill: "#515356",
      fontVariationSettings: "normal",
      paintOrder: "markers fill stroke",
      stopColor: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 1.875,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6901.1 737.09 20.844 16.651M6893.1 743.32l20.434 16.457",
    style: {
      InkscapeStroke: "none",
      fill: "none",
      fontVariationSettings: "normal",
      paintOrder: "markers fill stroke",
      stopColor: "#000",
      strokeDashoffset: 1.6197,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 1.875,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6841.3 734.14 8.97-6.531-2.043-12.223-47.458-.548-.122 16.604 7.944.387 3.797 16.089-13.392.113-9.47-10.735-10.189-.068.288 51.541 9.207-.391 11.785-15.07-.768-17.155 7.99-.174 11.338 10.193 15.85.42-4.948-18.836-6.91-4.95-.337-9.738z",
    style: {
      InkscapeStroke: "none",
      fillRule: "evenodd",
      fill: "#515356",
      fontVariationSettings: "normal",
      paintOrder: "markers fill stroke",
      stopColor: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 1.875,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6819.2 766.17-20.181-18.142M6779.4 737.23l20.512 18.925M6812.4 747.92l22.638 18.676M6808.6 731.83l14.577 10.978",
    style: {
      InkscapeStroke: "none",
      fill: "none",
      fontVariationSettings: "normal",
      paintOrder: "markers fill stroke",
      stopColor: "#000",
      strokeDashoffset: 1.6197,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 1.875,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6833.5 807.08 3.22-15.095-20.734-17.226-3.498 17.395-12.164 2.527.835 13.542z",
    style: {
      InkscapeStroke: "none",
      fillRule: "evenodd",
      fill: "#515356",
      fontVariationSettings: "normal",
      paintOrder: "markers fill stroke",
      stopColor: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 1.875,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6812.5 792.15 18.312 15.021",
    style: {
      InkscapeStroke: "none",
      fill: "none",
      fontVariationSettings: "normal",
      paintOrder: "markers fill stroke",
      stopColor: "#000",
      strokeDashoffset: 1.6197,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 1.875,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6813.7 843.82 37.988.905.774-17.87 22.413-3.498-.974 20.658-.742 17.345-50.592-.027c-2.706-6.431-5.683-12.229-8.867-17.513z",
    style: {
      InkscapeStroke: "none",
      fillRule: "evenodd",
      fill: "#515356",
      fontVariationSettings: "normal",
      paintOrder: "markers fill stroke",
      stopColor: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 1.875,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6851.7 844.73 21.471 16.635M6852.4 826.85l42.375 35.741",
    style: {
      InkscapeStroke: "none",
      fill: "none",
      fontVariationSettings: "normal",
      paintOrder: "markers fill stroke",
      stopColor: "#000",
      strokeDashoffset: 1.6197,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 1.875,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6873.9 844.02-.038.88 20.977 17.694 22.431-4.33 7.741-8.384.096-69.585-20.235-16.588-.69 69.46-7.457 7.704z",
    style: {
      InkscapeStroke: "none",
      fillRule: "evenodd",
      fill: "#515356",
      fontVariationSettings: "normal",
      paintOrder: "markers fill stroke",
      stopColor: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 1.875,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6896.7 840.87 20.546 17.393M6904.2 833.16l20.83 16.713",
    style: {
      InkscapeStroke: "none",
      fill: "none",
      fontVariationSettings: "normal",
      paintOrder: "markers fill stroke",
      stopColor: "#000",
      strokeDashoffset: 1.6197,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 1.875,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6741.6 620.9c-9.488 0-16.931.288-22.93 1.104l.049 17.295c4.416-5.078 14.481-4.962 22.881-4.961 12.201 0 28.225-.517 24.756 15.518-6.639 27.81-13.574 41.699-24.766 57.148-10.131-13.991-16.734-27.234-22.822-50.156l.137 48.643c4.32 11.389 8.617 22.779 12.03 34.004-3.363 11.05-7.588 22.254-11.845 33.467l.127 47.5c5.968-21.854 12.494-34.84 22.373-48.477 11.189 15.452 18.113 29.337 24.746 57.148 3.465 16.035-12.555 15.509-24.756 15.508-8.035-.001-17.614.128-22.305-4.297l.039 16.719c5.893.745 13.128 1.024 22.266 1.025 30.248.003 41.72-2.29 41.055-18.682-2.056-31.847-20.261-66.608-30.391-99.912 10.136-33.303 28.348-68.066 30.41-99.912.668-16.39-10.807-18.679-41.055-18.682z",
    style: {
      InkscapeStroke: "none",
      fillRule: "evenodd",
      fill: "#ffcc20",
      fontVariationSettings: "normal",
      paintOrder: "markers fill stroke",
      stopColor: "#000",
      strokeDashoffset: 1.6197,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 1.875,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6727.7 1045.3c.525-6.704 4.651-9.838 8.349-11.206-.978-1.045-1.737-2.349-2.25-3.797-3.306.253-6.517.66-9.555 1.221.876 1.605 2.838 7.663 3.456 13.782m21.37-15.003c-.515 1.45-1.28 2.754-2.258 3.799 3.697 1.368 7.823 4.502 8.347 11.206.538-6.004 2.519-12.067 3.46-13.79-3.36-.64-7.538-1.082-9.549-1.215",
    style: {
      InkscapeStroke: "none",
      fillRule: "evenodd",
      fill: "#515356",
      fontVariationSettings: "normal",
      paintOrder: "markers fill stroke",
      stopColor: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 1.875,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6742.4 1192 2.739-62.413",
    style: {
      InkscapeStroke: "none",
      fill: "none",
      fontVariationSettings: "normal",
      stopColor: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 1.875,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6703.7 1412.6a18.08 18.08 0 0 1 25.569 0 18.08 18.08 0 0 1 0 25.569 18.08 18.08 0 0 1-25.569 0 18.08 18.08 0 0 1 0-25.569M6754.4 1413.4a18.08 18.08 0 0 1 25.569 0 18.08 18.08 0 0 1 0 25.569 18.08 18.08 0 0 1-25.569 0 18.08 18.08 0 0 1 0-25.569M6755.1 1464a18.08 18.08 0 0 1 25.569 0 18.08 18.08 0 0 1 0 25.569 18.08 18.08 0 0 1-25.569 0 18.08 18.08 0 0 1 0-25.569M6702.9 1464.8a18.08 18.08 0 0 1 25.569 0 18.08 18.08 0 0 1 0 25.569 18.08 18.08 0 0 1-25.569 0 18.08 18.08 0 0 1 0-25.569",
    style: {
      InkscapeStroke: "none",
      fillRule: "evenodd",
      fill: "#bdbec0",
      fontVariationSettings: "normal",
      paintOrder: "markers fill stroke",
      stopColor: "#000",
      strokeDashoffset: 1.6197,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 1.875,
      stroke: "#000"
    }
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 748.23,
    cy: 400.4,
    rx: 35.514,
    ry: 6.747,
    style: {
      InkscapeStroke: "none",
      fillRule: "evenodd",
      fill: "#fff",
      fontVariationSettings: "normal",
      stopColor: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M748.23 272.56c-12.253 0-23.238 8.073-30.686 20.836.511 1.426 1.735 3.572 2.863 4.366 1.91 1.345 1.384 5.6-.888 8.815-1.397 1.978-1.431 2.077 4.157-.348 3.37-1.462 4.155-3.416 2.976-5.841-3.513-4.305-2.124-6.507-.04-7.26s4.113.44 3.355 6.472c.152 1.377.73 2.641 2.105 3.937 3.675 3.464 8.288 3.495 10.53 1.353 2.533-2.422 4.134-2.972.495-2.972-2.781 0-3.651-2.287-5.356-7.057 4.846-.024 3.091-7.881 7.57-5.34-1.72-6.985 1.332-8 2.918-10.595 1.586 2.595 4.638 3.61 2.919 10.594 4.479-2.54 2.724 5.317 7.57 5.34-1.705 4.77-2.575 7.058-5.356 7.058-3.64 0-2.038.55.495 2.972 2.242 2.142 6.855 2.111 10.53-1.353 1.375-1.296 1.954-2.56 2.105-3.937-.757-6.031 1.27-7.225 3.354-6.472s3.474 2.955-.04 7.26c-1.178 2.425-.392 4.379 2.977 5.841 5.588 2.426 5.554 2.326 4.157.348-2.272-3.216-2.798-7.47-.888-8.815 1.127-.793 2.35-2.937 2.861-4.363-7.448-12.763-18.43-20.839-30.684-20.839z",
    style: {
      fillRule: "evenodd",
      fill: "#fff",
      stopColor: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M754.44 325.6c.874 1.727 1.472 4.348 4.282 4.361-1.705 4.77-2.575 7.058-5.356 7.058-3.64 0-3.402.55-.869 2.971 2.242 2.143 10.533 2.112 14.208-1.352 1.246-1.174 1.838-2.321 2.05-3.55-1.183-5.945 1.067-7.349 3.238-6.766 2.17.584 3.751 2.478.684 7.513-.238 2.266 2.257 4.103 5.464 5.495 5.587 2.425 6.104 2.572 4.652-.305-1.022-2.237-.9-4.319-.316-5.071.586-.752 2.334-2.492 3.1-3.185.767-.693 1.894-.155 2.388.148.494.302 4.851 2.823 5.107 2.986.255.162 1.29.849 1.789.293.265-.296.625-.922 1.016-1.656v-.001c-.014-.057-.042-.109-.058-.165l-.244-.66c-3.196-6.82-22.991-7.951-41.134-8.114zm41.437 8.939v.01zm-53.851-8.937c-18.851.168-39.487 1.379-41.434 8.932v.01c.391.734.75 1.359 1.015 1.655.5.555 1.534-.131 1.79-.294.255-.163 4.612-2.683 5.106-2.986.494-.302 1.62-.84 2.387-.147s2.515 2.432 3.1 3.184c.586.753.707 2.835-.315 5.071-1.452 2.877-.936 2.73 4.652.305 3.207-1.392 5.702-3.228 5.464-5.494-3.067-5.035-1.487-6.93.684-7.513 2.17-.583 4.421.82 3.237 6.765.213 1.229.805 2.377 2.05 3.55 3.676 3.464 11.967 3.496 14.209 1.353 2.533-2.422 2.77-2.971-.87-2.971-2.78 0-3.65-2.288-5.355-7.058 2.81-.014 3.408-2.633 4.281-4.36zM744.89 356.63c-16.633.274-34.628 4.228-43.448 6.925.558 1.763-1.813 3.613-2.54 4.241 2.118 1.176 4.504 3.573 7.455.547 2.398-2.458 4.981-1.42 6.401-.37 1.209.894 3.521 2.927 2.577 6.803-.685 2.809.094 3.37 6.14-.223 1.153-.685 3.173-2.824 2.403-4.981-3.513-4.304-1.965-6.115.274-6.562s4.04-.115 3.041 5.774c.151 1.377 1.178 2.339 2.554 3.635 3.675 3.463 9.594 4.033 12.854 1.928 2.967-1.916 5.307-2.77 1.668-2.77-2.781 0-5.58-2.594-7.283-7.364 4.845-.024 3.845-7.776 8.324-5.235a18 18 0 0 1-.42-2.35zm6.67 0a17.4 17.4 0 0 1-.413 2.35c4.479-2.541 3.479 5.21 8.324 5.234-1.704 4.77-4.502 7.364-7.283 7.364-3.64 0-1.3.855 1.668 2.77 3.26 2.106 9.18 1.536 12.854-1.928 1.375-1.296 2.402-2.257 2.553-3.634-.999-5.89.803-6.221 3.042-5.774 2.239.446 3.787 2.257.274 6.562-.77 2.157 1.25 4.295 2.403 4.98 6.046 3.593 6.824 3.032 6.14.224-.944-3.877 1.368-5.91 2.576-6.804 1.42-1.05 4.003-2.087 6.401.371 2.951 3.025 5.337.63 7.453-.545-.726-.628-3.096-2.479-2.539-4.241-8.821-2.698-26.82-6.653-43.456-6.926z",
    style: {
      fillRule: "evenodd",
      fill: "#fff",
      fontVariationSettings: "normal",
      stopColor: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M774.47 407.62c-2.835.829-12.703 2.249-17.311 2.4 3.741 14.903 12.488 39.854 22.219 52.887.676.905 1.804 2.035 2.73 3.075l-.505.423c.14.151.264.295.408.448l13.28-10.641c-.297-.367-.608-.684-.902-1.067-10.139-13.186-15.719-33.878-19.92-47.525zm35.229 59.529L795.98 478.03c4.027 2.597 8.175 4.534 11.855 4.992.727-.02 1.437 0 2.184-.064 7.347-.627 9.92-6.767 11.16-14.656-3.948.588-7.787.165-11.48-1.153zm-1.863 15.873c-.053.002-.104-.001-.157 0 .052.007.105.02.157.025q.075 0 .152-.002-.076-.012-.152-.023m0 .025c-.114 0-.22-.013-.332-.011l1.187.129.043-.006c-.102-.017-.204-.03-.306-.047q-.295-.03-.592-.065z",
    style: {
      InkscapeStroke: "none",
      fillRule: "evenodd",
      fill: "#fff",
      fontVariationSettings: "normal",
      paintOrder: "markers fill stroke",
      stopColor: "#000",
      strokeDashoffset: 1.6197,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 0.75,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M825.19 342.11c-5.253-.75-7.22 7.319-7.918 14.338-.799 8.022 4.475 48.596 5.11 55.011.778 7.875 3.809 32.329 3.699 48.796-.106 15.747-5.5 21.797-14.453 22.784.736-.088 1.504-.131 2.195-.286 20.055-1.495 22.915-8.338 26.859-14.997 5.279-10.378 6.854-26.283 3.832-55.34-.736-7.073-5.265-44.012-7.551-62.304-3.297-2.854-7.043-5.844-9.316-7.11-.89-.496-1.707-.785-2.457-.892z",
    style: {
      InkscapeStroke: "none",
      fillRule: "evenodd",
      fill: "#fff",
      fontVariationSettings: "normal",
      paintOrder: "markers fill stroke",
      stopColor: "#000",
      strokeDashoffset: 1.6197,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 0.76761,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M838.64 320.02c-6.539 2.31-20.5 20.513-20.5 20.513l.082-.013c1.608-1.824 3.531-2.669 5.863-2.48 1.104.09 2.294.397 3.578.917 3.42 1.386 19.002 14.9 29.097 23.854h.004l16.334-16.106c-8.796-11.29-22.55-26.007-34.459-26.686z",
    style: {
      InkscapeStroke: "none",
      fillRule: "evenodd",
      fill: "#fff",
      fontVariationSettings: "normal",
      paintOrder: "markers fill stroke",
      stopColor: "#000",
      strokeDashoffset: 1.6197,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 0.76761,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M722.07 407.64c-4.2 13.648-9.854 34.321-19.992 47.506-.301.391-.617.72-.922 1.094l13.273 10.637c.145-.154.27-.298.41-.45l-.504-.421c.937-1.05 2.073-2.189 2.754-3.102 9.734-13.036 18.486-37.998 22.227-52.9.175.014.345.013.502.025-6.708-.41-11.188-.954-17.748-2.388zm-35.34 59.521c-3.682 1.306-7.507 1.72-11.441 1.133.018.115.032.235.05.35q.105.666.223 1.316c.193 1.013.41 1.995.666 2.927l.082.31c1.082 3.764 2.78 6.767 5.64 8.415l.005.002q.167.086.336.168c.329.172.66.341 1.02.479l.013.006c.934.355 1.97.589 3.125.687.747.065 1.457.044 2.184.065 3.671-.457 7.807-2.386 11.824-4.973zm1.902 15.857c-.05.006-.1.017-.15.023l.15.002c.05-.006.104-.018.155-.025-.052-.001-.103.002-.155 0m0 .025q-.284.034-.566.063-.164.026-.326.05l.037.005 1.176-.13c-.11 0-.211.016-.32.013z",
    style: {
      InkscapeStroke: "none",
      fillRule: "evenodd",
      fill: "#fff",
      fontVariationSettings: "normal",
      paintOrder: "markers fill stroke",
      stopColor: "#000",
      strokeDashoffset: 1.6197,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 0.75,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M671.28 342.11c-.75.107-1.566.396-2.457.892-2.274 1.266-5.847 3.944-9.264 6.694-2.286 18.292-6.868 55.647-7.603 62.721-3.022 29.055-1.447 44.961 3.832 55.34 3.945 6.658 6.804 13.501 26.859 14.996.69.155 1.458.198 2.195.286-8.954-.986-14.348-7.036-14.453-22.784-.11-16.467 2.92-40.92 3.7-48.796.634-6.415 5.907-46.99 5.109-55.01-.7-7.02-2.665-15.089-7.918-14.339z",
    style: {
      InkscapeStroke: "none",
      fillRule: "evenodd",
      fill: "#fff",
      fontVariationSettings: "normal",
      paintOrder: "markers fill stroke",
      stopColor: "#000",
      strokeDashoffset: 1.6197,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 0.76761,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M657.83 320.02c-11.909.68-26.204 14.86-35.001 26.15l16.051 15.822c10.095-8.955 26.508-21.649 29.927-23.035q1.924-.781 3.578-.917c2.332-.189 4.256.656 5.863 2.48l.082.013s-13.96-18.203-20.5-20.513z",
    style: {
      InkscapeStroke: "none",
      fillRule: "evenodd",
      fill: "#fff",
      fontVariationSettings: "normal",
      paintOrder: "markers fill stroke",
      stopColor: "#000",
      strokeDashoffset: 1.6197,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 0.76761,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      InkscapeStroke: "none",
      fill: "#ffd500",
      fontVariationSettings: "normal",
      paintOrder: "markers fill stroke",
      stopColor: "#000",
      strokeDashoffset: 1.6197,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 1.8248,
      stroke: "#000"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1885.2 531.08h83.083s4-.007 4 5.973-4 5.974-4 5.974h-83.083s-4-.014-4-5.974 4-5.973 4-5.973",
    style: {
      InkscapeStroke: "none",
      fillRule: "evenodd",
      fill: "#ffcc20",
      fontVariationSettings: "normal",
      paintOrder: "markers fill stroke",
      stopColor: "#000",
      strokeDashoffset: 1.5764,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 1.8248,
      stroke: "#000"
    },
    transform: "rotate(44.597 -229.167 1979.586)scale(.41099)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-1821.8 543.02 3.061 48.214 5.941 5.458 5.973-11.14-4.002-42.532zm-8.182 0 3.126 46.361 4.127 6.278 3.99-4.425-3.061-48.215zm-8.585 0 2.597 44.189 5.105 5.727 4.009-3.555-3.126-46.361zm-7.034 0-.537 43.911 4.717 5.649 5.45-5.37-2.596-44.19zm-7.315 0-6.302 39.77 3.696 2.53 3.434 5.18 5.95-3.57.537-43.91zm-6.935 0-3.758 37.512 2.378 6.576 2.013-4.318 6.302-39.77zm-6.427 0h6.427l-3.432 35.372-9.3 8.806-1.23-10.37zm-6.593 0-13.536 34.446 4.925 7.44 7.669-8.077 7.534-33.808zm-5.606 0-15.5 27.912 2.697 10.267 4.874-3.733 13.536-34.446z",
    style: {
      InkscapeStroke: "none",
      fillRule: "evenodd",
      fill: "#ffcc20",
      fontVariationSettings: "normal",
      paintOrder: "markers fill stroke",
      stopColor: "#000",
      strokeDashoffset: 1.5764,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 1.8248,
      stroke: "#000"
    },
    transform: "rotate(44.597 -229.167 1979.586)scale(.41099)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m661.98 393.92.67 5.9-5.98-2.11-.874 7.22 6.31-.62-2.159 6.392 7.22.874-.57-6.722 5.98 2.11.875-7.221-6.31.62 2.059-5.568zM720.62 431.43l-.827 4.847-4.27-3.057-2.36 5.542 5.162.961-3.191 4.586 5.541 2.36 1.096-5.478 4.27 3.057 2.361-5.542-5.163-.961 2.922-3.954zM655.15 328.13l-3.568 4.745-2.893-5.642-5.6 4.643 5.01 3.887-5.96 3.158 4.642 5.598 4.206-5.274 2.894 5.643 5.599-4.643-5.01-3.888 5.323-2.628z",
    style: {
      InkscapeStroke: "none",
      fillRule: "evenodd",
      fill: "#ffcc20",
      fontVariationSettings: "normal",
      paintOrder: "markers fill stroke",
      stopColor: "#000",
      strokeDashoffset: 0.64788,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 0.75,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M672.38 338.04c-1.104.09-2.294.396-3.578.917-3.42 1.386-19.836 14.08-29.931 23.035l2.811 2.772c1.52-1.235 20.33-17.97 27.14-21.76 7.123-3.967 9.576 5.424 10.374 13.446.799 8.021-4.475 48.596-5.11 55.01-.778 7.876-3.808 32.33-3.698 48.797.112 16.76 6.141 22.643 16.16 23.009.658.024 1.387-.155 2.085-.242-.727-.02-1.436 0-2.183-.065-9.253-.79-10.97-10.278-11.934-21.06-.386-4.314 3.812-44.68 4.621-52.663.808-7.984 3.096-27.937 4.352-39.814 1.361-12.883-.847-20.982-3.375-26.106-1.897-3.843-4.423-5.543-7.735-5.274zm16.254 144.98c5.076.15 9.611-.925 14.129-3.319l-2.121-1.763c-4.074 2.646-8.28 4.618-12.008 5.082m50.684-73.016c-3.74 14.902-12.493 39.864-22.227 52.9-.682.913-1.817 2.052-2.754 3.102l2.457 2.062c.684-.73 1.304-1.237 2.008-2.026 9.661-10.824 19.319-37.144 24.188-55.849a47 47 0 0 1-3.672-.19zM652.51 319.35c-11.883.11-24.478 14.72-32.734 23.81l3.05 3.007c8.796-11.29 23.092-25.47 35-26.15a20.2 20.2 0 0 0-5.316-.667z",
    style: {
      InkscapeStroke: "none",
      fillRule: "evenodd",
      fill: "#ffcc20",
      fontVariationSettings: "normal",
      paintOrder: "markers fill stroke",
      stopColor: "#000",
      strokeDashoffset: 0.64788,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 0.76761,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M655.05 353.37c-2.64 22.014-6.213 46.591-6.901 58.184-1.729 29.095-4.784 41.593 5.543 60.032 5.579 9.962 13.176 13.041 32.797 11.67a21.3 21.3 0 0 1-3.844-.503c-20.055-1.495-22.915-8.338-26.86-14.997-5.278-10.378-6.853-26.283-3.831-55.34.73-7.027 5.302-44.296 7.603-62.72-1.48 1.163-2.987 2.4-4.506 3.673zm33.286 129.69c-.538.082-1.079.175-1.59.184.8-.057 1.487-.071 2.328-.143-.275 0-.468-.036-.738-.04",
    style: {
      InkscapeStroke: "none",
      fillRule: "evenodd",
      fill: "#ffcc20",
      fontVariationSettings: "normal",
      paintOrder: "markers fill stroke",
      stopColor: "#000",
      strokeDashoffset: 0.64788,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 0.76761,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M718.35 406.61c-6.4 20.86-13.115 38.931-20.034 47.349l2.848 2.281c.304-.374.621-.699.922-1.09 10.139-13.186 15.793-33.862 19.994-47.51-1.342-.23-2.519-.764-3.73-1.03zm-36.557 59.88c-2.07.472-4.308.626-6.758.281.066.508.124 1.028.2 1.524 3.955.6 7.802.184 11.503-1.13l-.671-.534c.02 0 .038-.01.058-.012v0h-.004c-1.641.474-3.13.411-4.328-.125z",
    style: {
      InkscapeStroke: "none",
      fillRule: "evenodd",
      fill: "#ffcc20",
      fontVariationSettings: "normal",
      paintOrder: "markers fill stroke",
      stopColor: "#000",
      strokeDashoffset: 0.64788,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 0.75,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      InkscapeStroke: "none",
      fill: "#ffd500",
      fontVariationSettings: "normal",
      paintOrder: "markers fill stroke",
      stopColor: "#000",
      strokeDashoffset: 1.6197,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 1.8248,
      stroke: "#000"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1885.2 531.08h83.083s4-.007 4 5.973-4 5.974-4 5.974h-83.083s-4-.014-4-5.974 4-5.973 4-5.973",
    style: {
      InkscapeStroke: "none",
      fillRule: "evenodd",
      fill: "#ffcc20",
      fontVariationSettings: "normal",
      paintOrder: "markers fill stroke",
      stopColor: "#000",
      strokeDashoffset: 1.5764,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 1.8248,
      stroke: "#000"
    },
    transform: "matrix(-.29265 .28856 .28856 .29265 172.58 730.9)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-1821.8 543.02 3.061 48.214 5.941 5.458 5.973-11.14-4.002-42.532zm-8.182 0 3.126 46.361 4.127 6.278 3.99-4.425-3.061-48.215zm-8.585 0 2.597 44.189 5.105 5.727 4.009-3.555-3.126-46.361zm-7.034 0-.537 43.911 4.717 5.649 5.45-5.37-2.596-44.19zm-7.315 0-6.302 39.77 3.696 2.53 3.434 5.18 5.95-3.57.537-43.91zm-6.935 0-3.758 37.512 2.378 6.576 2.013-4.318 6.302-39.77zm-6.427 0h6.427l-3.432 35.372-9.3 8.806-1.23-10.37zm-6.593 0-13.536 34.446 4.925 7.44 7.669-8.077 7.534-33.808zm-5.606 0-15.5 27.912 2.697 10.267 4.874-3.733 13.536-34.446z",
    style: {
      InkscapeStroke: "none",
      fillRule: "evenodd",
      fill: "#ffcc20",
      fontVariationSettings: "normal",
      paintOrder: "markers fill stroke",
      stopColor: "#000",
      strokeDashoffset: 1.5764,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 1.8248,
      stroke: "#000"
    },
    transform: "matrix(-.29265 .28856 .28856 .29265 172.58 730.9)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m834.49 393.92-.67 5.9 5.98-2.11.874 7.22-6.31-.62 2.159 6.392-7.22.874.57-6.722-5.98 2.11-.875-7.221 6.31.62-2.059-5.568zM775.85 431.43l.827 4.847 4.27-3.057 2.36 5.542-5.162.961 3.191 4.586-5.541 2.36-1.096-5.478-4.27 3.057-2.361-5.542 5.163-.961-2.922-3.954zM841.25 327.85l3.623 4.704 2.828-5.675 5.651 4.578-4.964 3.944 5.997 3.09-4.578 5.651-4.267-5.226-2.828 5.676-5.652-4.578 4.965-3.945-5.353-2.567z",
    style: {
      InkscapeStroke: "none",
      fillRule: "evenodd",
      fill: "#ffcc20",
      fontVariationSettings: "normal",
      paintOrder: "markers fill stroke",
      stopColor: "#000",
      strokeDashoffset: 0.64788,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 0.75,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M824.09 338.04c-3.312-.269-5.838 1.431-7.734 5.275-2.529 5.124-4.737 13.223-3.375 26.106 1.255 11.877 3.543 31.83 4.351 39.814.809 7.983 5.007 48.349 4.621 52.662-.965 10.783-2.68 20.272-11.934 21.06-.747.065-1.456.044-2.183.065.698.087 1.427.266 2.086.242 10.019-.366 16.048-6.248 16.16-23.01.11-16.466-2.92-40.92-3.7-48.795-.634-6.416-5.908-46.99-5.109-55.011s3.251-17.413 10.375-13.446c6.81 3.792 24.779 21.356 26.298 22.59l2.822-2.782c-10.095-8.956-25.68-22.468-29.1-23.854-1.285-.52-2.475-.827-3.579-.917zm-16.254 144.98c-3.737-.465-7.955-2.446-12.039-5.103l-2.125 1.768c4.53 2.407 9.075 3.486 14.164 3.335m-54.354-72.821c4.87 18.704 14.526 45.02 24.186 55.844.696.78 1.308 1.28 1.984 2.001l2.457-2.066c-.926-1.04-2.054-2.169-2.73-3.073-9.738-13.042-18.492-38.024-22.23-52.923a65 65 0 0 1-3.668.218zM843.96 319.35c11.883.11 23.866 15.324 32.122 24.414l-2.98 2.939c-8.796-11.29-22.55-26.007-34.459-26.686a20.2 20.2 0 0 1 5.317-.667z",
    style: {
      InkscapeStroke: "none",
      fillRule: "evenodd",
      fill: "#ffcc20",
      fontVariationSettings: "normal",
      paintOrder: "markers fill stroke",
      stopColor: "#000",
      strokeDashoffset: 0.64788,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 0.76761,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M841.5 354.11c2.631 21.823 6.132 45.983 6.813 57.447 1.728 29.095 4.784 41.593-5.543 60.032-5.58 9.962-13.176 13.041-32.797 11.67a21.3 21.3 0 0 0 3.843-.503c20.055-1.495 22.915-8.338 26.86-14.997 5.278-10.378 6.853-26.283 3.831-55.34-.725-6.974-5.234-43.741-7.551-62.304zm-33.375 128.95c.538.082 1.079.175 1.59.184-.8-.057-1.487-.071-2.328-.143.275 0 .468-.036.738-.04",
    style: {
      InkscapeStroke: "none",
      fillRule: "evenodd",
      fill: "#ffcc20",
      fontVariationSettings: "normal",
      paintOrder: "markers fill stroke",
      stopColor: "#000",
      strokeDashoffset: 0.64788,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 0.76761,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M778.26 406.56c-1.106.343-2.425.744-3.791 1.06 4.2 13.649 9.78 34.34 19.919 47.525.294.382.604.7.902 1.066l2.848-2.285c-6.911-8.427-13.484-26.527-19.878-47.367zm36.386 59.918c-1.202.545-2.696.61-4.348.133h-.004v0c.021 0 .038.01.059.012l-.656.52c3.713 1.324 7.573 1.746 11.543 1.144.076-.496.133-1.016.199-1.524-2.463.347-4.713.19-6.793-.289z",
    style: {
      InkscapeStroke: "none",
      fillRule: "evenodd",
      fill: "#ffcc20",
      fontVariationSettings: "normal",
      paintOrder: "markers fill stroke",
      stopColor: "#000",
      strokeDashoffset: 0.64788,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 0.75,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M748.23 308.94c-16.6 0-33.373.879-39.961 5.804.163.852-.497 2.728-1.647 3.102 9.835-3.708 24.639-5.332 41.608-5.332s31.772 1.624 41.608 5.332c-1.15-.374-1.81-2.25-1.648-3.102-6.587-4.925-23.36-5.804-39.96-5.804z",
    style: {
      fillRule: "evenodd",
      fill: "#ffd500",
      fontVariationSettings: "normal",
      paintOrder: "markers fill stroke",
      stopColor: "#000",
      strokeDashoffset: 1.6197,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 0.73279,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M748.23 312.51c-16.969 0-31.772 1.624-41.608 5.332-3.541 1.151-4.05 5.362-3.555 7.808 11.357-5.6 27.06-5.858 41.819-5.867.398-2.883 2.23-3.935 3.344-5.758 1.115 1.824 2.947 2.875 3.345 5.758 14.757.01 30.462.266 41.819 5.867.494-2.446-.014-6.657-3.556-7.808-9.835-3.708-24.639-5.332-41.608-5.332z",
    style: {
      fillRule: "evenodd",
      fill: "#ffd500",
      fontVariationSettings: "normal",
      paintOrder: "markers fill stroke",
      stopColor: "#000",
      strokeDashoffset: 1.6197,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 0.73279,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M744.89 319.78c-14.757.01-30.462.266-41.819 5.867.247 1.222-.16 2.29-1.462 2.756-.666.238-1.018 2.7-1.018 6.131 1.939-7.558 22.58-8.769 41.436-8.937.632-1.252 1.406-2.049 3.288-.98-.51-2.077-.594-3.617-.426-4.837zm6.689 0c.168 1.22.085 2.76-.426 4.836 1.882-1.068 2.656-.271 3.289.98 18.856.17 39.497 1.38 41.436 8.938 0-3.43-.353-5.893-1.018-6.131-1.303-.465-1.71-1.534-1.463-2.756-11.357-5.601-27.061-5.858-41.819-5.867zM748.23 278.93c-1.586 2.595-4.637 3.61-2.918 10.594-4.479-2.54-2.725 5.316-7.57 5.34 1.704 4.77 2.574 7.058 5.355 7.058 3.64 0 2.04.55-.494 2.971-2.242 2.143-6.856 2.11-10.53-1.353-1.376-1.296-1.953-2.561-2.104-3.938.757-6.03-1.271-7.223-3.356-6.47-2.085.752-3.474 2.955.04 7.26 1.178 2.425.392 4.379-2.977 5.841-5.588 2.425-5.554 2.324-4.157.346 2.272-3.215 2.799-7.47.889-8.815-1.128-.794-2.352-2.94-2.863-4.367-.39-1.086-1.304-2.006-1.905-2.931-1.06-1.635-2.707-1.66-5.863.017-3.398 1.806-3.719-1.678-5.43-4.484-.277 2.545 1.364 9.146 2.63 13.4a3.5 3.5 0 0 1 2.056-.686 3.493 3.493 0 1 1 0 6.986 3 3 0 0 1-.38-.043c-.004 0-.008.006-.01.006.343 3.657-.915 6.242-.374 9.079 6.588-4.925 23.361-5.803 39.961-5.803s33.373.878 39.961 5.803c.54-2.83-.71-5.41-.375-9.05a4 4 0 0 1-.3.034 3.493 3.493 0 0 1-3.493-3.494 3.493 3.493 0 0 1 3.492-3.494 3.5 3.5 0 0 1 1.983.617c1.264-4.256 2.892-10.82 2.615-13.355-1.711 2.806-2.032 6.29-5.43 4.484-3.155-1.677-4.802-1.651-5.863-.017-.6.925-1.514 1.846-1.903 2.931-.51 1.426-1.737 3.573-2.865 4.368-1.91 1.344-1.383 5.599.889 8.814 1.398 1.978 1.431 2.08-4.156-.346-3.37-1.462-4.156-3.416-2.977-5.842 3.513-4.304 2.124-6.506.04-7.26-2.086-.752-4.111.44-3.354 6.471-.151 1.377-.73 2.642-2.106 3.938-3.675 3.464-8.29 3.496-10.53 1.353-2.534-2.421-4.134-2.97-.495-2.97 2.781 0 3.651-2.289 5.356-7.059-4.846-.024-3.092-7.88-7.57-5.34 1.719-6.984-1.333-7.999-2.919-10.594z",
    style: {
      fillRule: "evenodd",
      fill: "#ffd500",
      fontVariationSettings: "normal",
      paintOrder: "markers fill stroke",
      stopColor: "#000",
      strokeDashoffset: 1.6197,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 0.73279,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m744.93 244.51.65 7.294-7.268-.699v7.109l7.267-.698-.649 8.34h6.609l-.65-8.34 7.268.698v-7.109l-7.267.699.649-7.294z",
    style: {
      fillRule: "evenodd",
      fill: "#ffd500",
      fontVariationSettings: "normal",
      paintOrder: "markers fill stroke",
      stopColor: "#000",
      strokeDashoffset: 1.6197,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 0.61424,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M748.23 272.56c-12.253 0-23.238 8.073-30.686 20.836.511 1.426 1.735 3.572 2.863 4.366 1.91 1.345 1.384 5.6-.888 8.815-1.397 1.978-1.431 2.077 4.157-.348 3.37-1.462 4.155-3.416 2.976-5.841-3.513-4.305-2.124-6.507-.04-7.26s4.113.44 3.355 6.472c.152 1.377.73 2.641 2.105 3.937 3.675 3.464 8.288 3.495 10.53 1.352 2.533-2.42 4.134-2.97.495-2.97-2.781 0-3.651-2.288-5.356-7.058 4.846-.024 3.091-7.881 7.57-5.34-1.72-6.985 1.332-8 2.918-10.595 1.586 2.595 4.638 3.61 2.919 10.594 4.479-2.54 2.724 5.317 7.57 5.34-1.705 4.77-2.575 7.058-5.356 7.058-3.64 0-2.038.55.495 2.971 2.242 2.143 6.855 2.112 10.53-1.352 1.375-1.296 1.954-2.56 2.105-3.937-.757-6.031 1.27-7.225 3.354-6.472s3.474 2.955-.04 7.26c-1.178 2.425-.392 4.379 2.977 5.841 5.588 2.426 5.554 2.326 4.157.348-2.272-3.216-2.798-7.47-.888-8.815 1.127-.793 2.35-2.937 2.861-4.363-7.448-12.764-18.43-20.839-30.684-20.839z",
    style: {
      fill: "none",
      stopColor: "#000",
      strokeLinejoin: "round",
      strokeWidth: 0.73279,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M748.23 343.37c-16.6 0-40.52 1.81-47.107 6.734-1.065 1.225-2.254 3.152-3.206 5 9.286-5.223 33.345-7.211 50.314-7.211s41.027 1.988 50.314 7.21c-.953-1.847-2.142-3.774-3.207-4.999-6.587-4.924-30.508-6.734-47.107-6.734z",
    style: {
      fillRule: "evenodd",
      fill: "#ffd500",
      fontVariationSettings: "normal",
      paintOrder: "markers fill stroke",
      stopColor: "#000",
      strokeDashoffset: 1.6197,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 0.73279,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M748.23 314.03c-1.586 2.595-4.638 3.61-2.918 10.594-4.48-2.54-2.725 5.317-7.57 5.34 1.704 4.77 2.574 7.058 5.355 7.058 3.64 0 3.403.55.87 2.971-2.243 2.143-10.534 2.112-14.209-1.352-1.245-1.174-1.837-2.322-2.05-3.55 1.184-5.945-1.067-7.349-3.238-6.766-2.17.584-3.75 2.478-.684 7.513.24 2.266-2.256 4.103-5.463 5.495-5.588 2.425-6.104 2.572-4.652-.305 1.022-2.237.9-4.319.315-5.071s-2.333-2.492-3.1-3.185-1.893-.155-2.387.148c-.494.302-4.851 2.823-5.107 2.986-.255.162-1.29.85-1.789.293-.962-1.07-3.072-6.209-3.995-6.802-.767.872-1.034 3.126-1.364 4.24-1.272-.273-4.338-1.61-5.145-1.845-.133 1.591.486 4.406.861 5.319s1.982 2.617 2.245 4.008c.324 1.715-.261 3.083-.578 3.526-.316.444-.572 1.3.478 1.3 1.051 0 5.973.236 6.865.236s1.587 2.122.153 3.927c6.587-4.925 30.508-6.735 47.107-6.735 16.6 0 40.52 1.81 47.107 6.735-1.434-1.805-.739-3.927.153-3.927s5.814-.237 6.864-.237c1.051 0 .795-.855.478-1.299-.316-.443-.901-1.81-.577-3.526.263-1.391 1.87-3.095 2.245-4.008s.994-3.728.86-5.319c-.806.235-3.873 1.572-5.144 1.845-.33-1.114-.597-3.368-1.365-4.24-.922.593-3.032 5.731-3.994 6.802-.5.556-1.534-.13-1.79-.293-.255-.163-4.612-2.684-5.106-2.986s-1.62-.841-2.387-.148-2.515 2.433-3.1 3.185c-.586.752-.707 2.834.315 5.07 1.452 2.878.935 2.731-4.652.306-3.207-1.392-5.702-3.229-5.464-5.495 3.067-5.035 1.487-6.93-.684-7.513-2.17-.583-4.421.821-3.237 6.766-.213 1.229-.805 2.376-2.05 3.55-3.676 3.464-11.967 3.495-14.209 1.352-2.533-2.421-2.77-2.97.87-2.97 2.78 0 3.65-2.289 5.355-7.059-4.846-.024-3.091-7.88-7.57-5.34 1.72-6.984-1.332-8-2.918-10.594z",
    style: {
      fillRule: "evenodd",
      fill: "#ffd500",
      fontVariationSettings: "normal",
      paintOrder: "markers fill stroke",
      stopColor: "#000",
      strokeDashoffset: 1.6197,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 0.73279,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M748.23 347.89c-16.969 0-41.027 1.988-50.314 7.211-.667 1.253-1.533 3.665-1.346 5.453 7.796-6.594 25.464-8.971 49.333-9.114.725-1.115 1.652-1.952 2.327-3.057.675 1.105 1.602 1.942 2.327 3.057 23.869.143 41.537 2.52 49.333 9.114.187-1.788-.68-4.2-1.346-5.453-9.287-5.223-33.345-7.211-50.314-7.211",
    style: {
      fillRule: "evenodd",
      fill: "#ffd500",
      fontVariationSettings: "normal",
      paintOrder: "markers fill stroke",
      stopColor: "#000",
      strokeDashoffset: 1.6197,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 0.73279,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M745.91 351.44c-23.869.144-41.537 2.52-49.333 9.115.102.696.704 4.368 2.393 3.78 7.54-2.63 27.628-7.403 45.916-7.706-.282-2.524.258-4.012 1.024-5.189m4.654 0c.766 1.177 1.306 2.665 1.024 5.189 18.287.303 38.376 5.076 45.916 7.706 1.69.588 2.292-3.084 2.393-3.78-7.796-6.594-25.464-8.971-49.333-9.115M748.23 381.54c-18.094 0-32.779 1.042-43.334 5.455-1.254 4.95-2.155 4.278-1.904 7.08 12.216-6.024 29.553-7.188 45.238-7.188s33.022 1.164 45.238 7.189c.25-2.803-.65-2.131-1.904-7.081-10.555-4.413-25.24-5.455-43.334-5.455z",
    style: {
      fillRule: "evenodd",
      fill: "#ffd500",
      fontVariationSettings: "normal",
      paintOrder: "markers fill stroke",
      stopColor: "#000",
      strokeDashoffset: 1.6197,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 0.73279,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M748.23 386.89c-15.689 0-33.025 1.165-45.238 7.189 2.646 6.2 7.064 2.117 11.162 1.827a38.507 9.898 0 0 0-3.495 2.658c-3.573 1.39-2.734 4.65.267 4.188a38.507 9.898 0 0 0 37.305 7.547 38.507 9.898 0 0 0 37.302-7.547c2.977.462 3.83-2.737.365-4.147a38.507 9.898 0 0 0-3.402-2.707c4.043.4 8.366 4.283 10.97-1.82-12.214-6.023-29.546-7.188-45.235-7.188zm0 6.765a35.514 6.747 0 0 1 35.514 6.749 35.514 6.747 0 0 1-35.514 6.745 35.514 6.747 0 0 1-35.514-6.745 35.514 6.747 0 0 1 35.514-6.749M748.23 348.38c-1.586 2.595-4.637 3.612-2.918 10.596-4.479-2.54-3.479 5.21-8.324 5.234 1.704 4.77 4.502 7.364 7.283 7.364 3.64 0 1.3.855-1.668 2.771-3.26 2.105-9.18 1.534-12.855-1.93-1.375-1.296-2.402-2.255-2.553-3.632 1-5.89-.802-6.223-3.04-5.776-2.24.447-3.789 2.258-.276 6.563.77 2.157-1.249 4.295-2.402 4.98-6.046 3.593-6.825 3.031-6.141.223.944-3.877-1.368-5.91-2.576-6.803-1.42-1.05-4.003-2.087-6.4.371-3.962 4.062-6.907-1.653-9.547-1.06-.142 1.297 2.026 4.429 4.23 7.637a3.5 3.5 0 0 1 1.414-.311 3.493 3.493 0 0 1 3.494 3.492 3.5 3.5 0 0 1-1.222 2.64c.414.82.7 1.547.752 2.096 8.295-4.938 26.15-6.8 42.75-6.8s34.455 1.862 42.75 6.8c.052-.553.34-1.283.76-2.109a3.5 3.5 0 0 1-1.143-2.559 3.493 3.493 0 0 1 3.494-3.492 3.5 3.5 0 0 1 1.314.258c2.208-3.213 4.384-6.353 4.242-7.652-2.64-.593-5.585 5.122-9.546 1.06-2.398-2.458-4.98-1.421-6.4-.37-1.21.893-3.521 2.925-2.577 6.802.684 2.808-.095 3.37-6.14-.223-1.154-.685-3.173-2.823-2.403-4.98 3.513-4.305 1.965-6.116-.274-6.563s-4.042-.114-3.043 5.776c-.15 1.377-1.177 2.336-2.552 3.632-3.675 3.464-9.595 4.035-12.855 1.93-2.968-1.916-5.308-2.771-1.668-2.771 2.78 0 5.579-2.594 7.283-7.364-4.845-.023-3.845-7.775-8.324-5.234 1.72-6.984-1.332-8.001-2.918-10.596z",
    style: {
      fillRule: "evenodd",
      fill: "#ffd500",
      fontVariationSettings: "normal",
      paintOrder: "markers fill stroke",
      stopColor: "#000",
      strokeDashoffset: 1.6197,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 0.73279,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M748.23 376.04c-16.6 0-34.454 1.863-42.749 6.802.111 1.16.073 2.595-.585 4.156 10.555-4.412 25.24-5.454 43.334-5.454s32.78 1.042 43.334 5.454c-.657-1.561-.696-2.996-.584-4.156-8.296-4.94-26.15-6.802-42.75-6.802z",
    style: {
      fillRule: "evenodd",
      fill: "#ffd500",
      fontVariationSettings: "normal",
      paintOrder: "markers fill stroke",
      stopColor: "#000",
      strokeDashoffset: 1.6197,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 0.73279,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M795.02 363.54c-.582 1.769 1.806 3.63 2.535 4.26",
    style: {
      fill: "none",
      fontVariationSettings: "normal",
      stopColor: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 0.73279,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M745.1 265.85c-2.085 1.635-2.606 4.841-2.606 7.307 1.63-.323 3.728-.598 5.657-.598 1.984 0 3.805.168 5.82.626 0-2.466-.523-5.7-2.606-7.335z",
    style: {
      fillRule: "evenodd",
      fill: "#ffd500",
      fontVariationSettings: "normal",
      paintOrder: "markers fill stroke",
      stopColor: "#000",
      strokeDashoffset: 1.6197,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 0.61424,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M701.44 363.54c.582 1.769-1.806 3.63-2.535 4.26",
    style: {
      fill: "none",
      fontVariationSettings: "normal",
      stopColor: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 0.73279,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#ffd500",
      fontVariationSettings: "normal",
      paintOrder: "markers fill stroke",
      stopColor: "#000",
      strokeDashoffset: 1.5764,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 1.8248,
      stroke: "#000"
    },
    transform: "translate(508.41 228.99)scale(.41099)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 488.15,
    cy: 178.15,
    r: 8.5,
    style: {
      fillRule: "evenodd",
      fill: "#ffd500",
      fontVariationSettings: "normal",
      paintOrder: "markers fill stroke",
      stopColor: "#000",
      strokeDashoffset: 1.5764,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 1.8248,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 471.88,
    cy: 273.88,
    r: 8.5,
    style: {
      fillRule: "evenodd",
      fill: "#ffd500",
      fontVariationSettings: "normal",
      paintOrder: "markers fill stroke",
      stopColor: "#000",
      strokeDashoffset: 1.5764,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 1.8248,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 583.52,
    cy: 163.3,
    r: 8.5,
    style: {
      fillRule: "evenodd",
      fill: "#ffd500",
      fontVariationSettings: "normal",
      paintOrder: "markers fill stroke",
      stopColor: "#000",
      strokeDashoffset: 1.5764,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 1.8248,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 583.52,
    cy: 248.71,
    r: 8.5,
    style: {
      fillRule: "evenodd",
      fill: "#ffd500",
      fontVariationSettings: "normal",
      paintOrder: "markers fill stroke",
      stopColor: "#000",
      strokeDashoffset: 1.5764,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 1.8248,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 583.52,
    cy: 332.94,
    r: 8.5,
    style: {
      fillRule: "evenodd",
      fill: "#ffd500",
      fontVariationSettings: "normal",
      paintOrder: "markers fill stroke",
      stopColor: "#000",
      strokeDashoffset: 1.5764,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 1.8248,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 472.15,
    cy: 362.82,
    r: 8.5,
    style: {
      fillRule: "evenodd",
      fill: "#ffd500",
      fontVariationSettings: "normal",
      paintOrder: "markers fill stroke",
      stopColor: "#000",
      strokeDashoffset: 1.5764,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 1.8248,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -679.11,
    cy: 178.21,
    r: 8.5,
    style: {
      fillRule: "evenodd",
      fill: "#ffd500",
      fontVariationSettings: "normal",
      paintOrder: "markers fill stroke",
      stopColor: "#000",
      strokeDashoffset: 1.5764,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 1.8248,
      stroke: "#000"
    },
    transform: "scale(-1 1)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -695.18,
    cy: 273.92,
    r: 8.5,
    style: {
      fillRule: "evenodd",
      fill: "#ffd500",
      fontVariationSettings: "normal",
      paintOrder: "markers fill stroke",
      stopColor: "#000",
      strokeDashoffset: 1.5764,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 1.8248,
      stroke: "#000"
    },
    transform: "scale(-1 1)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -695.11,
    cy: 362.98,
    r: 8.5,
    style: {
      fillRule: "evenodd",
      fill: "#ffd500",
      fontVariationSettings: "normal",
      paintOrder: "markers fill stroke",
      stopColor: "#000",
      strokeDashoffset: 1.5764,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 1.8248,
      stroke: "#000"
    },
    transform: "scale(-1 1)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      strokeWidth: 1.875
    },
    transform: "scale(.4)rotate(-2.586 6889.1 80011.471)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5442.9 1564.6c-.778.037-1.746.608-2.88 1.524-1.921 1.55-11.329 9.388-14.61 12.118-.936 1.024-1.42 1.55-1.62 1.994 2.12-2.282 5.674-3.564 9.062-3.624 4.943.01 9.48 2.741 11.797 7.109.773-2.792.418-7.095.341-14.092-.04-3.684-.793-5.09-2.09-5.03z",
    style: {
      fillRule: "evenodd",
      fill: "#cd242b",
      paintOrder: "markers fill stroke",
      stopColor: "#000",
      strokeDashoffset: 1.6197,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 1.875,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5432.8,
    cy: 1590,
    r: 13.378,
    style: {
      InkscapeStroke: "none",
      fillRule: "evenodd",
      fill: "#cd242b",
      fontVariationSettings: "normal",
      paintOrder: "markers fill stroke",
      stopColor: "#000",
      strokeDashoffset: 1.6197,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 1.875,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5442.1 1599.7c9.015 4.972 12.25 17.705 12.25 32.763a57 57 0 0 1-.244 5.04c-5.331-5.303-12.258-8.526-21.318-8.526-9.072 0-16.004 3.164-21.338 8.369-.138-1.601-.235-3.22-.235-4.883 0-15.066 3.225-27.808 12.25-32.786 2.448 2.423 5.88 3.762 9.323 3.821 3.45-.062 6.866-1.366 9.313-3.799z",
    style: {
      fillRule: "evenodd",
      fill: "#cd242b",
      paintOrder: "markers fill stroke",
      stopColor: "#000",
      strokeDashoffset: 1.6197,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 1.875,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5432.8 1628.9c45.294 0 37.998 79.632 37.998 105.17h-.293a37.998 9.912 0 0 0 .293-.586 37.998 9.912 0 0 0-37.998-9.912 37.998 9.912 0 0 0-37.744 8.818l-.254-.02c0-25.534-7.296-103.47 37.998-103.47z",
    style: {
      InkscapeStroke: "none",
      fillRule: "evenodd",
      fill: "#cd242b",
      fontVariationSettings: "normal",
      paintOrder: "markers fill stroke",
      stopColor: "#000",
      strokeDashoffset: 1.6197,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 1.875,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: -5432.8,
    cy: 1733.5,
    rx: 37.998,
    ry: 9.912,
    style: {
      InkscapeStroke: "none",
      fillRule: "evenodd",
      fill: "#cd242b",
      fontVariationSettings: "normal",
      paintOrder: "markers fill stroke",
      stopColor: "#000",
      strokeDashoffset: 1.6197,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 1.875,
      stroke: "#000"
    },
    transform: "scale(-1 1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5452.9 1725c0-29.106-.027-41.178-3.214-53.024M5463.9 1727.1c.05-11.994.718-32.616-.771-43.035",
    style: {
      InkscapeStroke: "none",
      fill: "none",
      fontVariationSettings: "normal",
      paintOrder: "markers fill stroke",
      stopColor: "#000",
      strokeDashoffset: 1.6197,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 1.875,
      stroke: "#000"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      strokeWidth: 1.875
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5314.7 1292.4c0-6.458.084-7.472 4.328-10.991 1.672-1.387 13.295-11.078 15.466-12.831 3.025-2.442 4.974-2.383 4.974 3.511 0 5.716.025 7.44-3.023 10.028-1.823 1.547-13.74 11.423-15.768 13.081-3.72 3.043-5.977 3.702-5.977-2.799z",
    style: {
      fillRule: "evenodd",
      fill: "#cd242b",
      paintOrder: "markers fill stroke",
      stopColor: "#000",
      strokeDashoffset: 1.6197,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 1.875,
      stroke: "#000"
    },
    transform: "rotate(-2.594 2954.685 30976.995)scale(.4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5314.7 1307.2c0-6.458.084-7.472 4.328-10.991 1.672-1.387 13.295-11.078 15.466-12.831 3.025-2.442 4.974-2.383 4.974 3.511 0 5.716.025 7.44-3.023 10.028-1.823 1.547-13.74 11.423-15.768 13.081-3.72 3.043-5.977 3.702-5.977-2.799zM5314.7 1277.3c0-6.458.084-7.472 4.328-10.991 1.672-1.387 13.295-11.078 15.466-12.831 3.025-2.442 4.974-2.383 4.974 3.511 0 5.716.025 7.44-3.023 10.028-1.823 1.547-13.74 11.423-15.768 13.081-3.72 3.043-5.977 3.702-5.977-2.799zM5314.7 1246.9c0-6.458.084-7.472 4.328-10.991 1.672-1.387 13.295-11.078 15.466-12.831 3.025-2.442 4.974-2.383 4.974 3.511 0 5.716.025 7.44-3.023 10.028-1.823 1.547-13.74 11.423-15.768 13.081-3.72 3.043-5.977 3.702-5.977-2.799z",
    style: {
      fillRule: "evenodd",
      fill: "#cd242b",
      paintOrder: "markers fill stroke",
      stopColor: "#000",
      strokeDashoffset: 1.6197,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 1.875,
      stroke: "#000"
    },
    transform: "rotate(-2.594 2954.685 30976.995)scale(.4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5314.7 1262.1c0-6.458.084-7.472 4.328-10.991 1.672-1.387 13.295-11.078 15.466-12.831 3.025-2.442 4.974-2.383 4.974 3.511 0 5.716.025 7.44-3.023 10.028-1.823 1.547-13.74 11.423-15.768 13.081-3.72 3.043-5.977 3.702-5.977-2.799zM5314.7 1231.8c0-6.458.084-7.472 4.328-10.991 1.672-1.387 13.295-11.078 15.466-12.831 3.025-2.442 4.974-2.383 4.974 3.511 0 5.716.025 7.44-3.023 10.028-1.823 1.547-13.74 11.423-15.768 13.081-3.72 3.043-5.977 3.702-5.977-2.799zM5314.7 1383.4c0-6.458.084-7.472 4.328-10.991 1.672-1.387 13.295-11.078 15.466-12.831 3.025-2.442 4.974-2.383 4.974 3.511 0 5.716.025 7.44-3.023 10.028-1.823 1.547-13.74 11.423-15.768 13.081-3.72 3.043-5.977 3.702-5.977-2.799z",
    style: {
      fillRule: "evenodd",
      fill: "#cd242b",
      paintOrder: "markers fill stroke",
      stopColor: "#000",
      strokeDashoffset: 1.6197,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 1.875,
      stroke: "#000"
    },
    transform: "rotate(-2.594 2954.685 30976.995)scale(.4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5314.7 1398.6c0-6.458.084-7.472 4.328-10.991 1.672-1.387 13.295-11.078 15.466-12.831 3.025-2.442 4.974-2.383 4.974 3.511 0 5.716.025 7.44-3.023 10.028-1.823 1.547-13.74 11.423-15.768 13.081-3.72 3.043-5.977 3.702-5.977-2.799zM5314.7 1368.3c0-6.458.084-7.472 4.328-10.991 1.672-1.387 13.295-11.078 15.466-12.831 3.025-2.442 4.974-2.383 4.974 3.511 0 5.716.025 7.44-3.023 10.028-1.823 1.547-13.74 11.423-15.768 13.081-3.72 3.043-5.977 3.702-5.977-2.799zM5314.7 1337.9c0-6.458.084-7.472 4.328-10.991 1.672-1.387 13.295-11.078 15.466-12.831 3.025-2.442 4.974-2.383 4.974 3.511 0 5.716.025 7.44-3.023 10.028-1.823 1.547-13.74 11.423-15.768 13.081-3.72 3.043-5.977 3.702-5.977-2.799z",
    style: {
      fillRule: "evenodd",
      fill: "#cd242b",
      paintOrder: "markers fill stroke",
      stopColor: "#000",
      strokeDashoffset: 1.6197,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 1.875,
      stroke: "#000"
    },
    transform: "rotate(-2.594 2954.685 30976.995)scale(.4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5314.7 1353.1c0-6.458.084-7.472 4.328-10.991 1.672-1.387 13.295-11.078 15.466-12.831 3.025-2.442 4.974-2.383 4.974 3.511 0 5.716.025 7.44-3.023 10.028-1.823 1.547-13.74 11.423-15.768 13.081-3.72 3.043-5.977 3.702-5.977-2.799zM5314.7 1322.8c0-6.458.084-7.472 4.328-10.991 1.672-1.387 13.295-11.078 15.466-12.831 3.025-2.442 4.974-2.383 4.974 3.511 0 5.716.025 7.44-3.023 10.028-1.823 1.547-13.74 11.423-15.768 13.081-3.72 3.043-5.977 3.702-5.977-2.799zM5314.7 1474.4c0-6.458.084-7.472 4.328-10.991 1.672-1.387 13.295-11.078 15.466-12.831 3.025-2.442 4.974-2.383 4.974 3.511 0 5.716.025 7.44-3.023 10.028-1.823 1.547-13.74 11.423-15.768 13.081-3.72 3.043-5.977 3.702-5.977-2.799z",
    style: {
      fillRule: "evenodd",
      fill: "#cd242b",
      paintOrder: "markers fill stroke",
      stopColor: "#000",
      strokeDashoffset: 1.6197,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 1.875,
      stroke: "#000"
    },
    transform: "rotate(-2.594 2954.685 30976.995)scale(.4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5314.7 1489.5c0-6.458.084-7.472 4.328-10.991 1.672-1.387 13.295-11.078 15.466-12.831 3.025-2.442 4.974-2.383 4.974 3.511 0 5.716.025 7.44-3.023 10.028-1.823 1.547-13.74 11.423-15.768 13.081-3.72 3.043-5.977 3.702-5.977-2.799zM5314.7 1459.2c0-6.458.084-7.472 4.328-10.991 1.672-1.387 13.295-11.078 15.466-12.831 3.025-2.442 4.974-2.383 4.974 3.511 0 5.716.025 7.44-3.023 10.028-1.823 1.547-13.74 11.423-15.768 13.081-3.72 3.043-5.977 3.702-5.977-2.799zM5314.7 1428.9c0-6.458.084-7.472 4.328-10.991 1.672-1.387 13.295-11.078 15.466-12.831 3.025-2.442 4.974-2.383 4.974 3.511 0 5.716.025 7.44-3.023 10.028-1.823 1.547-13.74 11.423-15.768 13.081-3.72 3.043-5.977 3.702-5.977-2.799z",
    style: {
      fillRule: "evenodd",
      fill: "#cd242b",
      paintOrder: "markers fill stroke",
      stopColor: "#000",
      strokeDashoffset: 1.6197,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 1.875,
      stroke: "#000"
    },
    transform: "rotate(-2.594 2954.685 30976.995)scale(.4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5314.7 1444c0-6.458.084-7.472 4.328-10.991 1.672-1.387 13.295-11.078 15.466-12.831 3.025-2.442 4.974-2.383 4.974 3.511 0 5.716.025 7.44-3.023 10.028-1.823 1.547-13.74 11.423-15.768 13.081-3.72 3.043-5.977 3.702-5.977-2.799zM5314.7 1413.7c0-6.458.084-7.472 4.328-10.991 1.672-1.387 13.295-11.078 15.466-12.831 3.025-2.442 4.974-2.383 4.974 3.511 0 5.716.025 7.44-3.023 10.028-1.823 1.547-13.74 11.423-15.768 13.081-3.72 3.043-5.977 3.702-5.977-2.799zM5315.4 1549.6c0-6.458.084-7.472 4.328-10.991 1.672-1.387 13.295-11.078 15.466-12.831 3.025-2.442 4.974-2.383 4.974 3.511 0 5.716.025 7.44-3.023 10.028-1.823 1.547-13.74 11.423-15.768 13.081-3.72 3.043-5.977 3.702-5.977-2.799zM5314.7 1519.9c0-6.458.084-7.472 4.328-10.991 1.672-1.387 13.295-11.078 15.466-12.831 3.025-2.442 4.974-2.383 4.974 3.511 0 5.716.025 7.44-3.023 10.028-1.823 1.547-13.74 11.423-15.768 13.081-3.72 3.043-5.977 3.702-5.977-2.799z",
    style: {
      fillRule: "evenodd",
      fill: "#cd242b",
      paintOrder: "markers fill stroke",
      stopColor: "#000",
      strokeDashoffset: 1.6197,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 1.875,
      stroke: "#000"
    },
    transform: "rotate(-2.594 2954.685 30976.995)scale(.4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5314.7 1535c0-6.458.084-7.472 4.328-10.991 1.672-1.387 13.295-11.078 15.466-12.831 3.025-2.442 4.974-2.383 4.974 3.511 0 5.716.025 7.44-3.023 10.028-1.823 1.547-13.74 11.423-15.768 13.081-3.72 3.043-5.977 3.702-5.977-2.799zM5314.7 1504.7c0-6.458.084-7.472 4.328-10.991 1.672-1.387 13.295-11.078 15.466-12.831 3.025-2.442 4.974-2.383 4.974 3.511 0 5.716.025 7.44-3.023 10.028-1.823 1.547-13.74 11.423-15.768 13.081-3.72 3.043-5.977 3.702-5.977-2.799zM5314.7 1171.1c0-6.458.084-7.472 4.328-10.991 1.672-1.387 13.295-11.078 15.466-12.831 3.025-2.442 4.974-2.383 4.974 3.511 0 5.716.025 7.44-3.023 10.028-1.823 1.547-13.74 11.423-15.768 13.081-3.72 3.043-5.977 3.702-5.977-2.799z",
    style: {
      fillRule: "evenodd",
      fill: "#cd242b",
      paintOrder: "markers fill stroke",
      stopColor: "#000",
      strokeDashoffset: 1.6197,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 1.875,
      stroke: "#000"
    },
    transform: "rotate(-2.594 2954.685 30976.995)scale(.4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5314.7 1185.9c0-6.458.084-7.472 4.328-10.991 1.672-1.387 13.295-11.078 15.466-12.831 3.025-2.442 4.974-2.383 4.974 3.511 0 5.716.025 7.44-3.023 10.028-1.823 1.547-13.74 11.423-15.768 13.081-3.72 3.043-5.977 3.702-5.977-2.799zM5314.7 1156c0-6.458.084-7.472 4.328-10.991 1.672-1.387 13.295-11.078 15.466-12.831 3.025-2.442 4.974-2.383 4.974 3.511 0 5.716.025 7.44-3.023 10.028-1.823 1.547-13.74 11.423-15.768 13.081-3.72 3.043-5.977 3.702-5.977-2.799zM5314.7 1125.6c0-6.458.084-7.472 4.328-10.991 1.672-1.387 13.295-11.078 15.466-12.831 3.025-2.442 4.974-2.383 4.974 3.511 0 5.716.025 7.44-3.023 10.028-1.823 1.547-13.74 11.423-15.768 13.081-3.72 3.043-5.977 3.702-5.977-2.799z",
    style: {
      fillRule: "evenodd",
      fill: "#cd242b",
      paintOrder: "markers fill stroke",
      stopColor: "#000",
      strokeDashoffset: 1.6197,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 1.875,
      stroke: "#000"
    },
    transform: "rotate(-2.594 2954.685 30976.995)scale(.4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5314.7 1140.8c0-6.458.084-7.472 4.328-10.991 1.672-1.387 13.295-11.078 15.466-12.831 3.025-2.442 4.974-2.383 4.974 3.511 0 5.716.025 7.44-3.023 10.028-1.823 1.547-13.74 11.423-15.768 13.081-3.72 3.043-5.977 3.702-5.977-2.799zM5314.7 1110.5c0-6.458.084-7.472 4.328-10.991 1.672-1.387 13.295-11.078 15.466-12.831 3.025-2.442 4.974-2.383 4.974 3.511 0 5.716.025 7.44-3.023 10.028-1.823 1.547-13.74 11.423-15.768 13.081-3.72 3.043-5.977 3.702-5.977-2.799zM5314.7 1216.6c0-6.458.084-7.472 4.328-10.991 1.672-1.387 13.295-11.078 15.466-12.831 3.025-2.442 4.974-2.383 4.974 3.511 0 5.716.025 7.44-3.023 10.028-1.823 1.547-13.74 11.423-15.768 13.081-3.72 3.043-5.977 3.702-5.977-2.799z",
    style: {
      fillRule: "evenodd",
      fill: "#cd242b",
      paintOrder: "markers fill stroke",
      stopColor: "#000",
      strokeDashoffset: 1.6197,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 1.875,
      stroke: "#000"
    },
    transform: "rotate(-2.594 2954.685 30976.995)scale(.4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5314.7 1201.5c0-6.458.084-7.472 4.328-10.991 1.672-1.387 13.295-11.078 15.466-12.831 3.025-2.442 4.974-2.383 4.974 3.511 0 5.716.025 7.44-3.023 10.028-1.823 1.547-13.74 11.423-15.768 13.081-3.72 3.043-5.977 3.702-5.977-2.799zM5314.7 1095.3c0-6.458.084-7.472 4.328-10.991 1.672-1.387 13.295-11.078 15.466-12.831 3.025-2.442 4.974-2.383 4.974 3.511 0 5.716.025 7.44-3.023 10.028-1.823 1.547-13.74 11.423-15.768 13.081-3.72 3.043-5.977 3.702-5.977-2.799z",
    style: {
      fillRule: "evenodd",
      fill: "#cd242b",
      paintOrder: "markers fill stroke",
      stopColor: "#000",
      strokeDashoffset: 1.6197,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 1.875,
      stroke: "#000"
    },
    transform: "rotate(-2.594 2954.685 30976.995)scale(.4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5314.7 1080.2c0-6.458.084-7.472 4.328-10.991 1.672-1.387 13.295-11.078 15.466-12.831 3.025-2.442 4.974-2.383 4.974 3.511 0 5.716.025 7.44-3.023 10.028-1.823 1.547-13.74 11.423-15.768 13.081-3.72 3.043-5.977 3.702-5.977-2.799z",
    style: {
      fillRule: "evenodd",
      fill: "#cd242b",
      paintOrder: "markers fill stroke",
      stopColor: "#000",
      strokeDashoffset: 1.6197,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 1.875,
      stroke: "#000"
    },
    transform: "rotate(-2.594 2954.685 30976.995)scale(.4)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      strokeWidth: 1.875
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5314.7 1292.4c0-6.458.084-7.472 4.328-10.991 1.672-1.387 13.295-11.078 15.466-12.831 3.025-2.442 4.974-2.383 4.974 3.511 0 5.716.025 7.44-3.023 10.028-1.823 1.547-13.74 11.423-15.768 13.081-3.72 3.043-5.977 3.702-5.977-2.799z",
    style: {
      fillRule: "evenodd",
      fill: "#cd242b",
      paintOrder: "markers fill stroke",
      stopColor: "#000",
      strokeDashoffset: 1.6197,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 1.875,
      stroke: "#000"
    },
    transform: "matrix(.4 0 0 .4 -1382 72)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5314.7 1307.2c0-6.458.084-7.472 4.328-10.991 1.672-1.387 13.295-11.078 15.466-12.831 3.025-2.442 4.974-2.383 4.974 3.511 0 5.716.025 7.44-3.023 10.028-1.823 1.547-13.74 11.423-15.768 13.081-3.72 3.043-5.977 3.702-5.977-2.799zM5314.7 1277.3c0-6.458.084-7.472 4.328-10.991 1.672-1.387 13.295-11.078 15.466-12.831 3.025-2.442 4.974-2.383 4.974 3.511 0 5.716.025 7.44-3.023 10.028-1.823 1.547-13.74 11.423-15.768 13.081-3.72 3.043-5.977 3.702-5.977-2.799zM5314.7 1246.9c0-6.458.084-7.472 4.328-10.991 1.672-1.387 13.295-11.078 15.466-12.831 3.025-2.442 4.974-2.383 4.974 3.511 0 5.716.025 7.44-3.023 10.028-1.823 1.547-13.74 11.423-15.768 13.081-3.72 3.043-5.977 3.702-5.977-2.799z",
    style: {
      fillRule: "evenodd",
      fill: "#cd242b",
      paintOrder: "markers fill stroke",
      stopColor: "#000",
      strokeDashoffset: 1.6197,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 1.875,
      stroke: "#000"
    },
    transform: "matrix(.4 0 0 .4 -1382 72)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5314.7 1262.1c0-6.458.084-7.472 4.328-10.991 1.672-1.387 13.295-11.078 15.466-12.831 3.025-2.442 4.974-2.383 4.974 3.511 0 5.716.025 7.44-3.023 10.028-1.823 1.547-13.74 11.423-15.768 13.081-3.72 3.043-5.977 3.702-5.977-2.799zM5314.7 1231.8c0-6.458.084-7.472 4.328-10.991 1.672-1.387 13.295-11.078 15.466-12.831 3.025-2.442 4.974-2.383 4.974 3.511 0 5.716.025 7.44-3.023 10.028-1.823 1.547-13.74 11.423-15.768 13.081-3.72 3.043-5.977 3.702-5.977-2.799zM5314.7 1383.4c0-6.458.084-7.472 4.328-10.991 1.672-1.387 13.295-11.078 15.466-12.831 3.025-2.442 4.974-2.383 4.974 3.511 0 5.716.025 7.44-3.023 10.028-1.823 1.547-13.74 11.423-15.768 13.081-3.72 3.043-5.977 3.702-5.977-2.799z",
    style: {
      fillRule: "evenodd",
      fill: "#cd242b",
      paintOrder: "markers fill stroke",
      stopColor: "#000",
      strokeDashoffset: 1.6197,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 1.875,
      stroke: "#000"
    },
    transform: "matrix(.4 0 0 .4 -1382 72)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5314.7 1398.6c0-6.458.084-7.472 4.328-10.991 1.672-1.387 13.295-11.078 15.466-12.831 3.025-2.442 4.974-2.383 4.974 3.511 0 5.716.025 7.44-3.023 10.028-1.823 1.547-13.74 11.423-15.768 13.081-3.72 3.043-5.977 3.702-5.977-2.799zM5314.7 1368.3c0-6.458.084-7.472 4.328-10.991 1.672-1.387 13.295-11.078 15.466-12.831 3.025-2.442 4.974-2.383 4.974 3.511 0 5.716.025 7.44-3.023 10.028-1.823 1.547-13.74 11.423-15.768 13.081-3.72 3.043-5.977 3.702-5.977-2.799zM5314.7 1337.9c0-6.458.084-7.472 4.328-10.991 1.672-1.387 13.295-11.078 15.466-12.831 3.025-2.442 4.974-2.383 4.974 3.511 0 5.716.025 7.44-3.023 10.028-1.823 1.547-13.74 11.423-15.768 13.081-3.72 3.043-5.977 3.702-5.977-2.799z",
    style: {
      fillRule: "evenodd",
      fill: "#cd242b",
      paintOrder: "markers fill stroke",
      stopColor: "#000",
      strokeDashoffset: 1.6197,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 1.875,
      stroke: "#000"
    },
    transform: "matrix(.4 0 0 .4 -1382 72)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5314.7 1353.1c0-6.458.084-7.472 4.328-10.991 1.672-1.387 13.295-11.078 15.466-12.831 3.025-2.442 4.974-2.383 4.974 3.511 0 5.716.025 7.44-3.023 10.028-1.823 1.547-13.74 11.423-15.768 13.081-3.72 3.043-5.977 3.702-5.977-2.799zM5314.7 1322.8c0-6.458.084-7.472 4.328-10.991 1.672-1.387 13.295-11.078 15.466-12.831 3.025-2.442 4.974-2.383 4.974 3.511 0 5.716.025 7.44-3.023 10.028-1.823 1.547-13.74 11.423-15.768 13.081-3.72 3.043-5.977 3.702-5.977-2.799zM5314.7 1474.4c0-6.458.084-7.472 4.328-10.991 1.672-1.387 13.295-11.078 15.466-12.831 3.025-2.442 4.974-2.383 4.974 3.511 0 5.716.025 7.44-3.023 10.028-1.823 1.547-13.74 11.423-15.768 13.081-3.72 3.043-5.977 3.702-5.977-2.799z",
    style: {
      fillRule: "evenodd",
      fill: "#cd242b",
      paintOrder: "markers fill stroke",
      stopColor: "#000",
      strokeDashoffset: 1.6197,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 1.875,
      stroke: "#000"
    },
    transform: "matrix(.4 0 0 .4 -1382 72)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5314.7 1489.5c0-6.458.084-7.472 4.328-10.991 1.672-1.387 13.295-11.078 15.466-12.831 3.025-2.442 4.974-2.383 4.974 3.511 0 5.716.025 7.44-3.023 10.028-1.823 1.547-13.74 11.423-15.768 13.081-3.72 3.043-5.977 3.702-5.977-2.799zM5314.7 1459.2c0-6.458.084-7.472 4.328-10.991 1.672-1.387 13.295-11.078 15.466-12.831 3.025-2.442 4.974-2.383 4.974 3.511 0 5.716.025 7.44-3.023 10.028-1.823 1.547-13.74 11.423-15.768 13.081-3.72 3.043-5.977 3.702-5.977-2.799zM5314.7 1428.9c0-6.458.084-7.472 4.328-10.991 1.672-1.387 13.295-11.078 15.466-12.831 3.025-2.442 4.974-2.383 4.974 3.511 0 5.716.025 7.44-3.023 10.028-1.823 1.547-13.74 11.423-15.768 13.081-3.72 3.043-5.977 3.702-5.977-2.799z",
    style: {
      fillRule: "evenodd",
      fill: "#cd242b",
      paintOrder: "markers fill stroke",
      stopColor: "#000",
      strokeDashoffset: 1.6197,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 1.875,
      stroke: "#000"
    },
    transform: "matrix(.4 0 0 .4 -1382 72)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5314.7 1444c0-6.458.084-7.472 4.328-10.991 1.672-1.387 13.295-11.078 15.466-12.831 3.025-2.442 4.974-2.383 4.974 3.511 0 5.716.025 7.44-3.023 10.028-1.823 1.547-13.74 11.423-15.768 13.081-3.72 3.043-5.977 3.702-5.977-2.799zM5314.7 1413.7c0-6.458.084-7.472 4.328-10.991 1.672-1.387 13.295-11.078 15.466-12.831 3.025-2.442 4.974-2.383 4.974 3.511 0 5.716.025 7.44-3.023 10.028-1.823 1.547-13.74 11.423-15.768 13.081-3.72 3.043-5.977 3.702-5.977-2.799z",
    style: {
      fillRule: "evenodd",
      fill: "#cd242b",
      paintOrder: "markers fill stroke",
      stopColor: "#000",
      strokeDashoffset: 1.6197,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 1.875,
      stroke: "#000"
    },
    transform: "matrix(.4 0 0 .4 -1382 72)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5314.7 1560.2c0-6.072.084-7.026 4.328-10.335 1.672-1.304 13.295-10.417 15.466-12.065 3.025-2.297 4.974-2.241 4.974 3.302 0 5.374.025 6.997-3.023 9.43-1.823 1.454-13.74 10.741-15.768 12.3-3.72 2.862-5.977 3.482-5.977-2.631z",
    style: {
      fillRule: "evenodd",
      fill: "#cd242b",
      paintOrder: "markers fill stroke",
      stopColor: "#000",
      strokeDashoffset: 1.6197,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 1.8182,
      stroke: "#000"
    },
    transform: "matrix(.4 0 0 .4 -1382 72)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5314.7 1574.5c0-6.072.084-7.026 4.328-10.335 1.672-1.304 13.295-10.417 15.466-12.065 3.025-2.297 4.974-2.241 4.974 3.302 0 5.374.025 6.997-3.023 9.43-1.823 1.454-13.74 10.74-15.768 12.3-3.72 2.861-5.977 3.482-5.977-2.631zM5314.7 1546c0-6.072.084-7.026 4.328-10.335 1.672-1.304 13.295-10.417 15.466-12.065 3.025-2.297 4.974-2.241 4.974 3.302 0 5.374.025 6.997-3.023 9.43-1.823 1.454-13.74 10.741-15.768 12.3-3.72 2.862-5.977 3.482-5.977-2.631zM5314.7 1517.5c0-6.072.084-7.026 4.328-10.335 1.672-1.304 13.295-10.417 15.466-12.065 3.025-2.297 4.974-2.241 4.974 3.302 0 5.374.025 6.997-3.023 9.43-1.823 1.454-13.74 10.741-15.768 12.3-3.72 2.861-5.977 3.482-5.977-2.631z",
    style: {
      fillRule: "evenodd",
      fill: "#cd242b",
      paintOrder: "markers fill stroke",
      stopColor: "#000",
      strokeDashoffset: 1.6197,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 1.8182,
      stroke: "#000"
    },
    transform: "matrix(.4 0 0 .4 -1382 72)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5314.7 1531.7c0-6.072.084-7.026 4.328-10.335 1.672-1.304 13.295-10.417 15.466-12.065 3.025-2.297 4.974-2.241 4.974 3.302 0 5.374.025 6.997-3.023 9.43-1.823 1.454-13.74 10.741-15.768 12.3-3.72 2.861-5.977 3.481-5.977-2.632zM5314.7 1503.2c0-6.072.084-7.026 4.328-10.335 1.672-1.304 13.295-10.417 15.466-12.065 3.025-2.297 4.974-2.241 4.974 3.302 0 5.374.025 6.997-3.023 9.43-1.823 1.454-13.74 10.741-15.768 12.3-3.72 2.861-5.977 3.482-5.977-2.631z",
    style: {
      fillRule: "evenodd",
      fill: "#cd242b",
      paintOrder: "markers fill stroke",
      stopColor: "#000",
      strokeDashoffset: 1.6197,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 1.8182,
      stroke: "#000"
    },
    transform: "matrix(.4 0 0 .4 -1382 72)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5314.7 1171.1c0-6.458.084-7.472 4.328-10.991 1.672-1.387 13.295-11.078 15.466-12.831 3.025-2.442 4.974-2.383 4.974 3.511 0 5.716.025 7.44-3.023 10.028-1.823 1.547-13.74 11.423-15.768 13.081-3.72 3.043-5.977 3.702-5.977-2.799z",
    style: {
      fillRule: "evenodd",
      fill: "#cd242b",
      paintOrder: "markers fill stroke",
      stopColor: "#000",
      strokeDashoffset: 1.6197,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 1.875,
      stroke: "#000"
    },
    transform: "matrix(.4 0 0 .4 -1382 72)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5314.7 1185.9c0-6.458.084-7.472 4.328-10.991 1.672-1.387 13.295-11.078 15.466-12.831 3.025-2.442 4.974-2.383 4.974 3.511 0 5.716.025 7.44-3.023 10.028-1.823 1.547-13.74 11.423-15.768 13.081-3.72 3.043-5.977 3.702-5.977-2.799zM5314.7 1156c0-6.458.084-7.472 4.328-10.991 1.672-1.387 13.295-11.078 15.466-12.831 3.025-2.442 4.974-2.383 4.974 3.511 0 5.716.025 7.44-3.023 10.028-1.823 1.547-13.74 11.423-15.768 13.081-3.72 3.043-5.977 3.702-5.977-2.799zM5314.6 1125.6c0-6.458.084-7.472 4.328-10.991 1.672-1.387 13.295-11.078 15.466-12.831 3.025-2.442 4.974-2.383 4.974 3.511 0 5.716.025 7.44-3.023 10.028-1.823 1.547-13.74 11.423-15.768 13.081-3.72 3.043-5.977 3.702-5.977-2.799z",
    style: {
      fillRule: "evenodd",
      fill: "#cd242b",
      paintOrder: "markers fill stroke",
      stopColor: "#000",
      strokeDashoffset: 1.6197,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 1.875,
      stroke: "#000"
    },
    transform: "matrix(.4 0 0 .4 -1382 72)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5314.7 1140.8c0-6.458.084-7.472 4.328-10.991 1.672-1.387 13.295-11.078 15.466-12.831 3.025-2.442 4.974-2.383 4.974 3.511 0 5.716.025 7.44-3.023 10.028-1.823 1.547-13.74 11.423-15.768 13.081-3.72 3.043-5.977 3.702-5.977-2.799zM5314.7 1110.5c0-6.458.084-7.472 4.328-10.991 1.672-1.387 13.295-11.078 15.466-12.831 3.025-2.442 4.974-2.383 4.974 3.511 0 5.716.025 7.44-3.023 10.028-1.823 1.547-13.74 11.423-15.768 13.081-3.72 3.043-5.977 3.702-5.977-2.799zM5314.7 1216.6c0-6.458.084-7.472 4.328-10.991 1.672-1.387 13.295-11.078 15.466-12.831 3.025-2.442 4.974-2.383 4.974 3.511 0 5.716.025 7.44-3.023 10.028-1.823 1.547-13.74 11.423-15.768 13.081-3.72 3.043-5.977 3.702-5.977-2.799z",
    style: {
      fillRule: "evenodd",
      fill: "#cd242b",
      paintOrder: "markers fill stroke",
      stopColor: "#000",
      strokeDashoffset: 1.6197,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 1.875,
      stroke: "#000"
    },
    transform: "matrix(.4 0 0 .4 -1382 72)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5314.7 1201.5c0-6.458.084-7.472 4.328-10.991 1.672-1.387 13.295-11.078 15.466-12.831 3.025-2.442 4.974-2.383 4.974 3.511 0 5.716.025 7.44-3.023 10.028-1.823 1.547-13.74 11.423-15.768 13.081-3.72 3.043-5.977 3.702-5.977-2.799zM5314.7 1095.3c0-6.458.084-7.472 4.328-10.991 1.672-1.387 13.295-11.078 15.466-12.831 3.025-2.442 4.974-2.383 4.974 3.511 0 5.716.025 7.44-3.023 10.028-1.823 1.547-13.74 11.423-15.768 13.081-3.72 3.043-5.977 3.702-5.977-2.799z",
    style: {
      fillRule: "evenodd",
      fill: "#cd242b",
      paintOrder: "markers fill stroke",
      stopColor: "#000",
      strokeDashoffset: 1.6197,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 1.875,
      stroke: "#000"
    },
    transform: "matrix(.4 0 0 .4 -1382 72)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5314.7 1080.2c0-6.458.084-7.472 4.328-10.991 1.672-1.387 13.295-11.078 15.466-12.831 3.025-2.442 4.974-2.383 4.974 3.511 0 5.716.025 7.44-3.023 10.028-1.823 1.547-13.74 11.423-15.768 13.081-3.72 3.043-5.977 3.702-5.977-2.799zM5316 1050.1c-.917 6.21.823 5.557 4.316 2.783 2.928-2.435 12.794-5.035 14.785-6.642 2.163-1.746 1.99-1.602 3.584-2.428-.212-5.072-6.6-6.849-12.03-5.913-7.012 1.899-9.074 5.64-10.654 12.2z",
    style: {
      fillRule: "evenodd",
      fill: "#cd242b",
      paintOrder: "markers fill stroke",
      stopColor: "#000",
      strokeDashoffset: 1.6197,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 1.875,
      stroke: "#000"
    },
    transform: "matrix(.4 0 0 .4 -1382 72)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5314.7 1065c0-6.458 1.733-6.127 4.328-10.991 2.41-4.518 8.186-9.586 11.167-10.768 3.614-1.432 8.055-4.349 8.522 1.527.456 5.731.776 7.362-2.272 9.949-1.823 1.546-13.74 11.423-15.768 13.08-3.72 3.043-5.977 3.703-5.977-2.798z",
    style: {
      fillRule: "evenodd",
      fill: "#cd242b",
      paintOrder: "markers fill stroke",
      stopColor: "#000",
      strokeDashoffset: 1.6197,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 1.875,
      stroke: "#000"
    },
    transform: "matrix(.4 0 0 .4 -1382 72)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M770.31 498.54a.64.64 0 0 0-.605.465c.217.844.62 1.607 1.023 2.36 1.064 1.836 2.035 3.74 3.129 5.554a6.8 6.8 0 0 0 1.07 1.383c1.235.429 2.307.824 3.473 1.242.042-.011.083-.018.125-.031.081-.659-.098-1.315-.375-1.895-1.092-1.948-1.946-4.038-3.028-5.992-.819-1.882-2.701-2.93-4.554-3.035a.6.6 0 0 0-.258-.051z",
    style: {
      fillRule: "evenodd",
      fill: "#cd242b",
      paintOrder: "markers fill stroke",
      stopColor: "#000",
      strokeDashoffset: 1.6197,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 0.75,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M775.32 500.04c-.342-.033-.566.377-.516.738.213 1.143.966 2.084 1.395 3.145.914 1.737 1.646 3.598 2.695 5.246.17.28.342.526.52.75.994.36 2.083.738 2.992 1.082.566-.473.071-1.476-.106-2.102-.63-2.233-1.149-3.933-2.222-5.914-.816-1.895-2.76-2.849-4.606-2.902a.5.5 0 0 0-.152-.043M765.53 496.81c1.723.176 3.526.968 4.4 2.694 1.116 1.734 1.992 3.634 3.075 5.39.5.763.94 1.667.82 2.636-1.772.177-3.57-.762-4.573-2.361-1.306-1.766-2.389-3.712-3.626-5.534-.53-.772-.986-1.635-1.14-2.596.266-.335.693-.208 1.044-.229M754.58 493.3c1.439.068 2.924.563 3.982 1.667 1.234 1.482 2.228 3.195 3.32 4.805.666 1.21 1.989 2.112 2.028 3.643-1.712.638-3.624-.1-5.02-1.217-1.195-1.106-2.014-2.583-2.954-3.93-.826-1.406-2.062-2.665-2.361-4.346.053-.498.584-.835 1.005-.622",
    style: {
      fillRule: "evenodd",
      fill: "#cd242b",
      paintOrder: "markers fill stroke",
      stopColor: "#000",
      strokeDashoffset: 1.6197,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 0.75,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M759.71 495.21c1.663.038 3.45.549 4.565 1.984 1.262 1.619 2.216 3.488 3.387 5.181.595.932 1.482 1.962 1.387 3.148-1.533.437-3.121-.327-4.335-1.324-1.3-1.175-2.171-2.776-3.192-4.216-.837-1.26-1.706-2.499-2.47-3.814-.149-.443.162-1.127.658-.959M749.14 491.74c1.845.045 3.732 1.01 4.656 2.809 1.214 1.921 2.355 3.903 3.726 5.7.357.518.662 1.099.758 1.747-1.55.843-3.385.174-4.836-.602-1.513-1.128-2.287-3.017-3.246-4.65-.73-1.41-1.64-2.816-1.966-4.401.047-.429.529-.797.908-.603",
    style: {
      fillRule: "evenodd",
      fill: "#cd242b",
      paintOrder: "markers fill stroke",
      stopColor: "#000",
      strokeDashoffset: 1.6197,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 0.75,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m748.24 492.08-.078.062c.03.066.066.128.074.2.01-.082.046-.154.082-.227zm-.004.262c-.325 1.585-1.235 2.993-1.965 4.402-.77 1.311-1.424 2.78-2.433 3.895l-.145.41c3.123 1.91 6.525 1.67 8.974-.365-.562-.618-1.63-2.246-2.466-3.94-.73-1.41-1.64-2.817-1.965-4.402",
    style: {
      InkscapeStroke: "none",
      fillRule: "evenodd",
      fill: "#cd242b",
      fontVariationSettings: "normal",
      paintOrder: "markers fill stroke",
      stopColor: "#000",
      strokeDashoffset: 1.6197,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 0.75,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      strokeWidth: 2.1783
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5222.8 1280.1c-5.157 3.042-7.37 9.713-5.865 15.379 1.048 5.292 2.27 10.564 2.772 15.946.146 3.65 5.536 5.28 6.806 1.332 3.11-3.746 3.732-9.099 2.431-13.693-1.2-5.533-2.067-11.16-3.491-16.632-.405-1.122-1.209-2.599-2.653-2.333z",
    style: {
      fillRule: "evenodd",
      fill: "#cd242b",
      paintOrder: "markers fill stroke",
      stopColor: "#000",
      strokeDashoffset: 1.6197,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2.1783,
      stroke: "#000"
    },
    transform: "matrix(.34604 -.01071 .0106 .34225 -1107.7 190.79)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5214 1292c-4.452 3.299-7.212 9.127-5.986 14.659l3.372 18.477c1.98 4.285 7.403.501 7.984-2.864 2.554-4.725 1.146-10.277.094-15.214-1.171-4.83-1.23-10.036-3.747-14.452-.447-.433-1.089-.727-1.717-.606zM5230 1268.7c-4.026 3.354-5.566 9.052-4.38 14.078 1.03 5.27 2.386 10.481 2.936 15.833.015 2.845 3.521 5.966 5.79 3.032 3.854-3.68 4.745-9.568 3.378-14.557-1.243-5.501-2.16-11.097-3.465-16.566-.517-1.873-2.527-3.985-4.259-1.82zM5246.7 1244.1c-4.831 3.471-6.396 10.229-4.495 15.719 1.444 5.217 3.045 10.405 3.916 15.758.313 3.638 5.81 5.114 6.834 1.013 2.81-3.973 2.98-9.347 1.358-13.824-1.51-5.427-2.86-10.902-4.595-16.264-.549-1.147-1.456-2.854-3.018-2.402z",
    style: {
      fillRule: "evenodd",
      fill: "#cd242b",
      paintOrder: "markers fill stroke",
      stopColor: "#000",
      strokeDashoffset: 1.6197,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2.1783,
      stroke: "#000"
    },
    transform: "matrix(.34604 -.01071 .0106 .34225 -1107.7 190.79)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5237.8 1258c-3.823 3.582-4.98 9.37-3.504 14.305 1.334 5.207 3 10.335 3.85 15.655.169 2.828 3.825 5.808 5.938 2.747 3.638-3.893 4.152-9.83 2.504-14.726-1.564-5.433-2.81-10.978-4.434-16.376-.618-1.838-2.735-3.871-4.354-1.605zM5254.2 1231.3c-4.159 3.301-6.053 9.24-4.52 14.327 1.093 4.44 2.338 8.86 3.668 13.23.583 2.794.908 8.779 5.22 7.323 4.044-2.482 5.022-8.065 4.434-12.467-.752-4.662-2.715-9.02-3.671-13.636-1.125-3.011-1.201-8.212-5.131-8.777zM5165.5 1345.6c-4.635 2.963-7.912 8.545-6.933 14.138.873 6.228 1.923 12.347 2.796 18.576 1.803 4.385 7.356 1.144 8.168-2.268 3.137-4.995 1.477-11.038.653-16.437-.963-4.317-.338-9.23-2.598-13.12-.42-.68-1.288-1.124-2.086-.888z",
    style: {
      fillRule: "evenodd",
      fill: "#cd242b",
      paintOrder: "markers fill stroke",
      stopColor: "#000",
      strokeDashoffset: 1.6197,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2.1783,
      stroke: "#000"
    },
    transform: "matrix(.34604 -.01071 .0106 .34225 -1107.7 190.79)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5156.8 1357.7c.033 11.732-.82 16.8-2.948 27.512 2.882 1.2 6.074.872 6.82-1.272 1.378-5.738.335-7.446-.342-12.49-1.37-4.342-.08-10.52-3.53-13.75zM5175.3 1333.9c-4.364 3.096-7.557 8.45-6.688 13.928.88 6.063 1.864 12.116 2.38 18.224 1.382 4.662 7.76 1.875 8.487-1.814 3.211-5.018 1.434-11.155.645-16.603-.934-4.486-.21-10.034-3.292-13.657l-.755-.206zM5195.1 1310.3c-4.3 3.166-7.386 8.527-6.538 13.981.863 6.048 1.83 12.086 2.302 18.181 1.352 4.668 7.722 1.829 8.39-1.855 2.652-4.129 1.886-9.323 1.06-13.88-.96-5.058-.862-10.338-2.653-15.217-.366-.973-1.56-1.637-2.561-1.21z",
    style: {
      fillRule: "evenodd",
      fill: "#cd242b",
      paintOrder: "markers fill stroke",
      stopColor: "#000",
      strokeDashoffset: 1.6197,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2.1783,
      stroke: "#000"
    },
    transform: "matrix(.34604 -.01071 .0106 .34225 -1107.7 190.79)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5185.3 1322.1c-4.331 3.133-7.479 8.484-6.628 13.951.862 6.055 1.833 12.1 2.32 18.201 1.368 4.663 7.733 1.843 8.443-1.833 3.19-5.02 1.441-11.149.657-16.596-.929-4.481-.207-10.019-3.265-13.646l-.752-.205zM5204.5 1302.2c-4.368 3.272-7.207 8.991-5.95 14.468l3.416 18.725c2.22 4.135 7.375.06 8.01-3.218 2.375-4.591 1.245-9.968.063-14.73-1.453-4.91-.664-10.981-4.063-15.015l-.709-.26zM5283.9 1179.6c-4.079 3.678-6.09 9.798-4.139 15.058q2.879 9.32 5.582 18.693c2.087 3.853 6.887.207 7.265-2.986 2.146-4.685.69-10.005-1.013-14.583-1.876-4.91-2.543-10.263-5.074-14.918-.564-.834-1.582-1.463-2.621-1.265z",
    style: {
      fillRule: "evenodd",
      fill: "#cd242b",
      paintOrder: "markers fill stroke",
      stopColor: "#000",
      strokeDashoffset: 1.6197,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2.1783,
      stroke: "#000"
    },
    transform: "matrix(.34604 -.01071 .0106 .34225 -1107.7 190.79)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5276.7 1192.1c-4.039 3.71-6.046 9.798-4.137 15.064q2.82 9.309 5.465 18.67c2.081 3.853 6.86.184 7.235-2.994 2.15-4.678.716-9.995-.965-14.578-1.847-4.904-2.487-10.245-4.995-14.896-.555-.833-1.567-1.475-2.603-1.266zM5291.5 1166.7c-4.099 3.663-6.144 9.789-4.174 15.053q2.926 9.33 5.683 18.71c2.01 3.803 6.847.403 7.22-2.802 2.265-4.706.827-10.143-.949-14.762-1.931-4.904-2.557-10.289-5.137-14.94-.572-.836-1.6-1.46-2.643-1.26zM5307.6 1141a2.2 2.2 0 0 0-.78.01c-4.19 3.589-6.359 9.715-4.342 15.01 1.934 6.224 3.861 12.447 5.795 18.671 1.751 3.096 5.128 1.509 6.768-.952-.16-.888-.256-1.956-.211-3.42.135-4.429.265-6.66 1.345-8.552-.448-1.758-1.062-3.482-1.683-5.12-1.791-4.748-2.508-9.903-4.978-14.388-.447-.625-1.15-1.129-1.914-1.258z",
    style: {
      fillRule: "evenodd",
      fill: "#cd242b",
      paintOrder: "markers fill stroke",
      stopColor: "#000",
      strokeDashoffset: 1.6197,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2.1783,
      stroke: "#000"
    },
    transform: "matrix(.34604 -.01071 .0106 .34225 -1107.7 190.79)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5299.1 1153.8c-4.14 3.625-6.237 9.768-4.242 15.037l5.752 18.734c2.104 3.862 6.977.284 7.369-2.959 2.293-4.995.54-10.63-1.351-15.456-1.727-4.66-2.4-9.724-4.868-14.098-.579-.836-1.611-1.467-2.66-1.258zM5261.7 1218.4c-4.006 3.183-5.91 8.837-4.561 13.783 1.105 4.51 2.433 8.98 3.817 13.407.686 2.878.917 9.125 5.374 7.729 4.04-2.491 4.977-8.096 4.35-12.49-.791-4.66-2.78-9.01-3.774-13.625-1.15-3.024-1.264-8.235-5.206-8.804z",
    style: {
      fillRule: "evenodd",
      fill: "#cd242b",
      paintOrder: "markers fill stroke",
      stopColor: "#000",
      strokeDashoffset: 1.6197,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2.1783,
      stroke: "#000"
    },
    transform: "matrix(.34604 -.01071 .0106 .34225 -1107.7 190.79)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5269 1205.4c-4.028 3.719-6.043 9.784-4.178 15.063l5.337 18.642c2.082 3.832 6.821.158 7.21-2.994 2.158-4.67.764-9.987-.89-14.58-1.819-4.894-2.422-10.219-4.893-14.867-.55-.832-1.557-1.464-2.586-1.264zM5316.1 1131.3c-.15 0-.3-.019-.452.01-4.191 3.589-6.37 9.726-4.354 15.021 1.607 5.172 3.223 10.342 4.83 15.514.644-1.181 1.628-2.227 3.24-3.558l.068-.418c-2.714 1.433-4.23.491-4.05-5.349.202-6.608.327-8.328 3.739-11.315l.046-.756c-2.177.798-3.403-.433-3.244-5.603.044-1.45.103-2.499.176-3.544z",
    style: {
      fillRule: "evenodd",
      fill: "#cd242b",
      paintOrder: "markers fill stroke",
      stopColor: "#000",
      strokeDashoffset: 1.6197,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2.1783,
      stroke: "#000"
    },
    transform: "matrix(.34604 -.01071 .0106 .34225 -1107.7 190.79)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M667.28 654.31c-1.781.283-2.948 1.83-3.837 3.265-.95 1.47-1.89 2.946-2.837 4.418.766 1.375 2.53 1.86 3.999 1.561 1.595-.288 2.707-1.612 3.47-2.95.724-1.548 2.017-2.709 2.84-4.184.527-1.554-1.557-1.997-2.68-2.016q-.477-.046-.955-.094z",
    style: {
      fillRule: "evenodd",
      fill: "#cd242b",
      paintOrder: "markers fill stroke",
      stopColor: "#000",
      strokeDashoffset: 1.6197,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 0.75,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M672.63 655.72c-2.03.714-2.96 2.799-4.092 4.45-.732 1.093-1.415 2.218-2.11 3.335 1.27 1.232 3.26 1.74 4.928 1.079 1.519-.65 2.263-2.25 3.13-3.548.676-1.477 2.216-2.557 2.508-4.164-.811-1.29-2.655-1.253-3.995-1.23l-.358.075zM661.33 653.05c-1.781.282-2.952 1.825-3.839 3.263-.95 1.473-1.889 2.953-2.834 4.43.77 1.372 2.538 1.839 4.003 1.534 1.592-.293 2.702-1.615 3.465-2.951.726-1.544 2.02-2.7 2.84-4.173.517-1.552-1.563-1.985-2.682-2.008zM651.12 650.53q-.353.001-.68.059c-.058.469-.555.875-.945 1.152-1.72 1.153-3.075 2.758-4.773 3.934-.547.668-1.036 1.377-1.34 2.195 1.527 1.365 4.053 1.988 5.793.664 1.654-1.244 2.582-3.197 4.222-4.457.933-.606 1.665-2.303.317-2.89-.833-.323-1.713-.52-2.594-.657z",
    style: {
      fillRule: "evenodd",
      fill: "#cd242b",
      paintOrder: "markers fill stroke",
      stopColor: "#000",
      strokeDashoffset: 1.6197,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 0.75,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M655.61 651.87a3.2 3.2 0 0 0-1.16.262c.072.709-.444 1.557-1.047 1.949-1.506 1.156-2.418 2.892-3.836 4.133-.332.531-.672 1.058-.992 1.597 1.46 1.342 3.857 1.81 5.543.618 1.683-1.165 2.27-3.258 3.582-4.743.573-.772 1.724-1.83 1.168-2.816-.612-.785-1.713-.898-2.637-.95a3 3 0 0 0-.621-.05zM647.59 648.49c-.057.532-.696.876-1.18 1.094-1.958.816-3.63 2.177-5.586 2.996-.25.103-.513.182-.78.234h-.005c-.286.273-.573.547-.851.828-.166.345-.94.723-.446 1.13 2.764 3.264 4.06 2.197 5.86.995 1.758-1.183 3.135-2.841 4.898-4.023.548-.39 1.32-1.031.77-1.75-.455-.704-1.294-.99-2.036-1.278a3.2 3.2 0 0 0-.644-.226zM705.17 659.84c-2.093-.412-4.117.96-5.12 2.728-1.153 1.672-2.147 3.445-3.22 5.167-.62.806.194 1.572.986 1.696 2.027.632 4.351-.32 5.404-2.152 1.092-1.635 2.047-3.357 3.132-4.997.465-.576 1.155-1.942.079-2.275-.407-.141-.84-.118-1.261-.167M712.06 660.14c-1.836-.297-3.893.205-5.14 1.648-1.459 2.06-2.686 4.28-4.121 6.358-.529.719-.01 1.736.9 1.67 1.944.576 4.23-.177 5.341-1.902 1.148-1.591 1.925-3.424 3.163-4.957.704-.683 1.49-2.272.233-2.804l-.366-.013zM698.68 659.38c-2.113-.348-4.021 1.196-4.957 2.976a716 716 0 0 0-3.382 5.33c1.347 1.674 4.031 1.677 5.657.418 1.422-1.154 2.08-2.922 3.088-4.4.718-1.074 1.469-2.133 2.04-3.296-.277-1.064-1.598-.922-2.446-1.028M686.24 657.83c-1.827-.325-3.382 1.015-4.299 2.456-.994 1.56-2.055 3.083-2.984 4.682-.221.527-.622 1.223.113 1.529 1.68 1.206 4.226.882 5.589-.659 1.329-1.457 1.99-3.388 3.318-4.85.714-.773 1.495-2.453.031-2.899-.554-.232-1.177-.235-1.768-.259",
    style: {
      fillRule: "evenodd",
      fill: "#cd242b",
      paintOrder: "markers fill stroke",
      stopColor: "#000",
      strokeDashoffset: 1.6197,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 0.75,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M692.43 658.69c-2.128-.336-3.946 1.325-4.868 3.088a175 175 0 0 0-3.193 5.113c1.034 1.22 2.823 1.57 4.317 1.126 1.87-.56 2.817-2.398 3.71-3.976.72-1.472 2.247-2.57 2.512-4.236.04-1.117-1.74-.965-2.478-1.115zM679.02 656.79c-2.163.455-3.163 2.619-4.306 4.267-.75 1.216-1.653 2.418-2.176 3.728 1.245 1.391 3.488 1.768 5.108.808 1.77-1.04 2.475-3.088 3.613-4.684.723-.924 2.298-2.386 1.18-3.542-.982-.602-2.307-.591-3.419-.577M742.56 660.31c-2.23-.462-4.704.677-5.75 2.755-1.193 1.837-2.278 3.744-3.5 5.563-.513.73.123 1.663.978 1.599 1.736.324 3.683-.184 4.848-1.56 1.21-1.549 2.093-3.318 3.188-4.945.617-.87 1.969-2.141.963-3.193-.2-.13-.461-.158-.727-.219",
    style: {
      fillRule: "evenodd",
      fill: "#cd242b",
      paintOrder: "markers fill stroke",
      stopColor: "#000",
      strokeDashoffset: 1.6197,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 0.75,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M743.88 661.91c-1.306 1.326-2.109 3.058-3.086 4.625-.442 1.116-2.028 2.184-1.273 3.469 1.462.679 3.313.479 4.714-.38v0c-.235-.27-.363-.843-.363-1.816 0-2.583.033-2.987 1.73-4.394-.411.07-1.678 1.346-1.722-1.5zM736.14 660.26c-2.092-.27-4.284.797-5.349 2.62-1.22 1.744-2.11 3.702-3.422 5.383-.649.812-.183 2.17.97 2.016 2.127.352 4.317-.721 5.396-2.578 1.084-1.713 1.956-3.559 3.299-5.097.612-.72.9-2.502-.546-2.322zM723.79 660.24c-2.248-.209-4.501 1.08-5.499 3.099-1.11 1.661-2 3.463-3.193 5.07-.442.573-.546 1.752.478 1.72 1.535.416 3.333.218 4.566-.85 1.486-1.29 2.248-3.168 3.293-4.794.577-1.207 2.117-2.195 1.848-3.662-.19-.656-.974-.523-1.493-.583",
    style: {
      fillRule: "evenodd",
      fill: "#cd242b",
      paintOrder: "markers fill stroke",
      stopColor: "#000",
      strokeDashoffset: 1.6197,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 0.75,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M730.27 660.34a5.12 5.12 0 0 0-4.5 1.232c-1.404 1.416-2.24 3.279-3.313 4.94-.446 1.037-1.441 1.896-1.512 3.046.249.975 1.584.7 2.355.782 2.15.02 3.834-1.54 4.764-3.356.913-1.754 2.107-3.329 3.172-4.974.415-.788.106-1.862-.966-1.67M717.67 660.21c-1.919-.126-4.017.639-5.026 2.357-1.291 1.93-2.407 3.974-3.758 5.865-.767.99.555 1.983 1.53 1.768 1.866.287 3.849-.633 4.802-2.271 1.176-1.673 2.055-3.54 3.308-5.162.549-.614 1.183-2.005.137-2.457-.324-.093-.662-.068-.993-.1zM645.45 646.18c-.285.224-.694.355-1.027.445-2.063.498-5.234 1.965-7.293 2.465q-.434.104-.801.086c-.135.09-.273.171-.406.262-.23.306-1.062.53-.657 1.023 1.835 3.497 2.01 3.378 5.555 2.114 1.955-.819 3.627-2.18 5.586-2.997.614-.276 1.494-.75 1.094-1.562-.31-.779-1.078-1.227-1.75-1.652-.096-.073-.2-.124-.301-.184z",
    style: {
      fillRule: "evenodd",
      fill: "#cd242b",
      paintOrder: "markers fill stroke",
      stopColor: "#000",
      strokeDashoffset: 1.6197,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 0.75,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M643.83 643.34c-.102.018-.207.042-.3.055-1.998.21-5.15 1.147-7.145 1.36-.431.044-.794.01-1.106-.099-.516.254-1.3.344-1.187 1.759.452 2.209.93 3.187 3.035 2.683 2.06-.5 5.23-1.967 7.293-2.464.65-.176 1.592-.507 1.325-1.372-.183-.818-.573-1.268-1.17-1.793-.131-.138-.629-.021-.745-.129",
    style: {
      fillRule: "evenodd",
      fill: "#cd242b",
      paintOrder: "markers fill stroke",
      stopColor: "#000",
      strokeDashoffset: 1.6197,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 0.75,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M643.9 640.21c-.386.253-.878.28-1.723.344-2.096.179-3.7.527-5.765.351-.251-.111-1.342.03-1.922-.546-.312.181-.729 1.333-.497 1.832.167 1.974.353 2.768 2.39 2.558 1.996-.213 5.148-1.15 7.145-1.36.631-.083 1.557-.268 1.407-1.05-.074-.714-.545-1.618-1.035-2.129",
    style: {
      fillRule: "evenodd",
      fill: "#cd242b",
      paintOrder: "markers fill stroke",
      stopColor: "#000",
      strokeDashoffset: 1.6197,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 0.75,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M635.6 636.25c-.757.401-1.19 1.205-1.477 3.055-.037 1.797 1.94 1.45 2.29 1.605 2.065.175 3.67-.172 5.765-.351 1.534-.116 1.923-.083 2.574-1.575.26-.478.33-1.145.317-1.785-.498.405-1.008.347-2.059.262-2.098-.148-3.736-.057-5.75-.55-.209-.135-1.128-.17-1.66-.661",
    style: {
      fillRule: "evenodd",
      fill: "#cd242b",
      paintOrder: "markers fill stroke",
      stopColor: "#000",
      strokeDashoffset: 1.6197,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 0.75,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636.8 632.36c-.612.37-1.075 1.12-1.55 2.61-.317 1.769 1.69 1.734 2.01 1.94 2.015.494 3.653.404 5.75.552 1.534.123 1.916.215 2.79-1.157.466-.611.625-1.647.652-2.472-.689.693-1.16.583-2.414.367-2.076-.338-3.719-.393-5.68-1.067-.19-.15-1.065-.265-1.558-.773",
    style: {
      fillRule: "evenodd",
      fill: "#cd242b",
      paintOrder: "markers fill stroke",
      stopColor: "#000",
      strokeDashoffset: 1.6197,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 0.75,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M637.61 629.12c-.358.41-.701 1.004-1.074 1.887-.475 1.733 1.527 1.882 1.828 2.117 1.96.674 3.603.729 5.68 1.066 1.515.262 1.883.39 2.878-.898.258-.28.443-.674.583-1.098-.461.339-.963.38-1.848-.024-1.779-.631-5.223-2.023-7.031-2.574a2.9 2.9 0 0 1-1.016-.477zM644.53 619.4c-1.072.138-1.823 1.07-2.582 2.09-.549.825.57 1.539 1.262 1.726 1.68.59 5.19 2.435 6.84 3.098 1.47.744 1.812-.18 2.718-1.41.252-.393.497-.936.532-1.418-.416.289-.877.32-1.606-.125-1.59-.794-4.938-2.918-6.566-3.64a2.7 2.7 0 0 1-.598-.321",
    style: {
      fillRule: "evenodd",
      fill: "#cd242b",
      paintOrder: "markers fill stroke",
      stopColor: "#000",
      strokeDashoffset: 1.6197,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 0.75,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M638.96 625.41c-.714.411-1.082 1.433-1.754 2.418-.546.899.673 1.608 1.414 1.777 1.808.552 5.253 1.943 7.031 2.575 1.593.724 1.953.053 3.043-1.313.215-.26.475-.627.63-.988-.462.265-.968.252-1.798-.172-1.787-.728-5.237-2.31-7.058-2.957-.593-.164-1.462-.69-1.508-1.34",
    style: {
      fillRule: "evenodd",
      fill: "#cd242b",
      paintOrder: "markers fill stroke",
      stopColor: "#000",
      strokeDashoffset: 1.6197,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 0.75,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M641.71 622.33c-1.23-.016-1.67 1.307-2.602 2.54-.601.888.614 1.67 1.364 1.878 1.821.648 5.271 2.229 7.058 2.957 1.593.814 1.992.15 3.172-1.187.48-.529 1.22-1.509.629-2.004-.326.124-.718.083-1.277-.2-1.65-.663-5.16-2.508-6.84-3.097-.43-.117-1.025-.439-1.281-.864-.077-.01-.152-.022-.223-.024zM646.87 616.02c-1.14-.01-1.692 1.273-2.56 2.262-.615.778.148 1.198.822 1.441 1.628.723 4.975 2.846 6.566 3.64 1.406.86 1.821-.033 2.824-1.187.229-.3.454-.7.575-1.094-.23-.05-.483-.168-.782-.39-1.476-.912-4.245-2.884-5.764-3.73a2.7 2.7 0 0 1-.609-.414c-.273-.093-.828-.526-1.072-.528",
    style: {
      fillRule: "evenodd",
      fill: "#cd242b",
      paintOrder: "markers fill stroke",
      stopColor: "#000",
      strokeDashoffset: 1.6197,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 0.75,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M650.27 613.5c-.98.039-1.806.776-2.656 1.586-.664.703.296 1.58.93 1.875 1.518.846 4.289 2.818 5.765 3.73 1.291.96 1.773.125 2.848-.91.053-.058.103-.137.156-.203-.044-.028-.082-.04-.129-.074-1.547-.902-4.24-3.36-5.828-4.191-.63-.273-1.564-1.081-1.086-1.813z",
    style: {
      fillRule: "evenodd",
      fill: "#cd242b",
      paintOrder: "markers fill stroke",
      stopColor: "#000",
      strokeDashoffset: 1.6197,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 0.75,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M652.99 611.64c-.994.086-1.814.88-2.652 1.75-.659.759.358 1.635 1.02 1.922 1.588.831 4.28 3.29 5.827 4.191.266.187.491.286.7.344.534-.336.974-.595 1.886-1.234.186-.149.323-.334.5-.489-.277-.038-.578-.18-.937-.5-1.437-1.07-3.836-3.811-5.32-4.816-.387-.222-.877-.687-1.024-1.168",
    style: {
      fillRule: "evenodd",
      fill: "#cd242b",
      paintOrder: "markers fill stroke",
      stopColor: "#000",
      strokeDashoffset: 1.6197,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 0.75,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M656.09 609.34c-1.012-.044-1.925.663-2.867 1.442-.74.68.168 1.667.793 2.027 1.485 1.004 3.884 3.746 5.32 4.816.359.32.66.462.938.5a16 16 0 0 0 1.53-1.496c-1.32-1.262-3.35-4.125-4.69-5.254-.55-.398-1.278-1.375-.684-1.988a2 2 0 0 0-.34-.047",
    style: {
      fillRule: "evenodd",
      fill: "#cd242b",
      paintOrder: "markers fill stroke",
      stopColor: "#000",
      strokeDashoffset: 1.6197,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 0.75,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.26 608.12c-.908-.016-1.8.538-2.727 1.152-.806.599-.006 1.68.579 2.102 1.341 1.129 3.37 3.991 4.69 5.254.498-.57.907-1.188 1.31-1.813-1.087-1.507-2.359-3.534-3.313-4.492-.544-.472-1.25-1.619-.395-2.144l.075-.04a2 2 0 0 0-.22-.02z",
    style: {
      fillRule: "evenodd",
      fill: "#cd242b",
      paintOrder: "markers fill stroke",
      stopColor: "#000",
      strokeDashoffset: 1.6197,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 0.75,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M661.89 607.25c-.798.034-1.627.457-2.48.922-.856.526-.15 1.672.394 2.144.954.958 2.226 2.985 3.313 4.493a15.4 15.4 0 0 0 1.378-2.676c-.571-.941-1.137-1.84-1.625-2.395-.513-.505-1.144-1.693-.257-2.164q.14-.064.28-.125a2.1 2.1 0 0 0-.663-.187q-.17-.019-.34-.012z",
    style: {
      fillRule: "evenodd",
      fill: "#cd242b",
      paintOrder: "markers fill stroke",
      stopColor: "#000",
      strokeDashoffset: 1.6197,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 0.75,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M664.94 606.82c-.739.043-1.522.383-2.328.758-.887.47-.256 1.658.258 2.164.487.555 1.053 1.454 1.625 2.394a15.6 15.6 0 0 0 1.093-5.265 2.3 2.3 0 0 0-.648-.051z",
    style: {
      fillRule: "evenodd",
      fill: "#cd242b",
      paintOrder: "markers fill stroke",
      stopColor: "#000",
      strokeDashoffset: 1.6197,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 0.75,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      strokeWidth: 1.875
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5380.8 1076.4c-.66.017-1.324.446-1.514 1.162.543 2.111 1.552 4.019 2.559 5.899 2.661 4.59 5.087 9.35 7.822 13.887a17 17 0 0 0 2.676 3.457c3.086 1.072 5.768 2.06 8.682 3.105.104-.027.207-.046.312-.078.203-1.647-.244-3.286-.937-4.736-2.73-4.87-4.866-10.096-7.569-14.98-2.048-4.706-6.753-7.328-11.387-7.588a1.5 1.5 0 0 0-.644-.127z",
    style: {
      fillRule: "evenodd",
      fill: "#cd242b",
      paintOrder: "markers fill stroke",
      stopColor: "#000",
      strokeDashoffset: 1.6197,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 1.875,
      stroke: "#000"
    },
    transform: "matrix(-.4 0 0 .4 2878.5 67.969)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5393.3 1080.1c-.855-.083-1.416.942-1.29 1.846.534 2.857 2.416 5.21 3.487 7.861 2.286 4.344 4.114 8.995 6.738 13.115.425.703.856 1.315 1.3 1.875 2.484.902 5.207 1.846 7.48 2.705 1.414-1.181.178-3.69-.264-5.254-1.577-5.583-2.873-9.834-5.557-14.785-2.039-4.737-6.901-7.123-11.514-7.256a1.2 1.2 0 0 0-.38-.107zM5368.8 1072c4.307.441 8.814 2.42 11.001 6.734 2.79 4.336 4.978 9.087 7.685 13.475 1.252 1.908 2.35 4.169 2.052 6.59-4.432.444-8.926-1.905-11.433-5.902-3.267-4.414-5.972-9.28-9.065-13.835-1.326-1.93-2.467-4.087-2.853-6.49.668-.838 1.735-.52 2.612-.572zM5341.5 1063.3c3.597.17 7.31 1.408 9.954 4.166 3.087 3.706 5.57 7.99 8.301 12.014 1.664 3.024 4.972 5.28 5.07 9.108-4.28 1.594-9.06-.25-12.55-3.044-2.988-2.764-5.036-6.458-7.386-9.823-2.065-3.517-5.155-6.665-5.903-10.868.133-1.244 1.461-2.086 2.514-1.554z",
    style: {
      fillRule: "evenodd",
      fill: "#cd242b",
      paintOrder: "markers fill stroke",
      stopColor: "#000",
      strokeDashoffset: 1.6197,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 1.875,
      stroke: "#000"
    },
    transform: "matrix(-.4 0 0 .4 2878.5 67.969)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5354.3 1068c4.158.094 8.627 1.372 11.412 4.96 3.155 4.047 5.542 8.72 8.468 12.954 1.488 2.328 3.705 4.903 3.469 7.869-3.833 1.092-7.805-.819-10.84-3.31-3.247-2.937-5.427-6.94-7.979-10.541-2.094-3.151-4.264-6.246-6.176-9.535-.371-1.106.407-2.816 1.646-2.397zM5327.9 1059.4c4.613.113 9.33 2.524 11.64 7.023 3.035 4.802 5.888 9.756 9.315 14.249.893 1.296 1.656 2.748 1.895 4.369-3.875 2.106-8.462.433-12.09-1.507-3.784-2.819-5.717-7.54-8.115-11.625-1.823-3.523-4.102-7.04-4.915-11.002.118-1.071 1.322-1.993 2.27-1.507z",
    style: {
      fillRule: "evenodd",
      fill: "#cd242b",
      paintOrder: "markers fill stroke",
      stopColor: "#000",
      strokeDashoffset: 1.6197,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 1.875,
      stroke: "#000"
    },
    transform: "matrix(-.4 0 0 .4 2878.5 67.969)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      strokeWidth: 2.1783
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5222.8 1280.1c-5.157 3.042-7.37 9.713-5.865 15.379 1.048 5.292 2.27 10.564 2.772 15.946.146 3.65 5.536 5.28 6.806 1.332 3.11-3.746 3.732-9.099 2.431-13.693-1.2-5.533-2.067-11.16-3.491-16.632-.405-1.122-1.209-2.599-2.653-2.333z",
    style: {
      fillRule: "evenodd",
      fill: "#cd242b",
      paintOrder: "markers fill stroke",
      stopColor: "#000",
      strokeDashoffset: 1.6197,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2.1783,
      stroke: "#000"
    },
    transform: "matrix(-.34604 -.01071 -.0106 .34225 2604.1 190.79)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5214 1292c-4.452 3.299-7.212 9.127-5.986 14.659l3.372 18.477c1.98 4.285 7.403.501 7.984-2.864 2.554-4.725 1.146-10.277.094-15.214-1.171-4.83-1.23-10.036-3.747-14.452-.447-.433-1.089-.727-1.717-.606zM5230 1268.7c-4.026 3.354-5.566 9.052-4.38 14.078 1.03 5.27 2.386 10.481 2.936 15.833.015 2.845 3.521 5.966 5.79 3.032 3.854-3.68 4.745-9.568 3.378-14.557-1.243-5.501-2.16-11.097-3.465-16.566-.517-1.873-2.527-3.985-4.259-1.82zM5246.7 1244.1c-4.831 3.471-6.396 10.229-4.495 15.719 1.444 5.217 3.045 10.405 3.916 15.758.313 3.638 5.81 5.114 6.834 1.013 2.81-3.973 2.98-9.347 1.358-13.824-1.51-5.427-2.86-10.902-4.595-16.264-.549-1.147-1.456-2.854-3.018-2.402z",
    style: {
      fillRule: "evenodd",
      fill: "#cd242b",
      paintOrder: "markers fill stroke",
      stopColor: "#000",
      strokeDashoffset: 1.6197,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2.1783,
      stroke: "#000"
    },
    transform: "matrix(-.34604 -.01071 -.0106 .34225 2604.1 190.79)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5237.8 1258c-3.823 3.582-4.98 9.37-3.504 14.305 1.334 5.207 3 10.335 3.85 15.655.169 2.828 3.825 5.808 5.938 2.747 3.638-3.893 4.152-9.83 2.504-14.726-1.564-5.433-2.81-10.978-4.434-16.376-.618-1.838-2.735-3.871-4.354-1.605zM5254.2 1231.3c-4.159 3.301-6.053 9.24-4.52 14.327 1.093 4.44 2.338 8.86 3.668 13.23.583 2.794.908 8.779 5.22 7.323 4.044-2.482 5.022-8.065 4.434-12.467-.752-4.662-2.715-9.02-3.671-13.636-1.125-3.011-1.201-8.212-5.131-8.777zM5165.5 1345.6c-4.635 2.963-7.912 8.545-6.933 14.138.873 6.228 1.923 12.347 2.796 18.576 1.803 4.385 7.356 1.144 8.168-2.268 3.137-4.995 1.477-11.038.653-16.437-.963-4.317-.338-9.23-2.598-13.12-.42-.68-1.288-1.124-2.086-.888z",
    style: {
      fillRule: "evenodd",
      fill: "#cd242b",
      paintOrder: "markers fill stroke",
      stopColor: "#000",
      strokeDashoffset: 1.6197,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2.1783,
      stroke: "#000"
    },
    transform: "matrix(-.34604 -.01071 -.0106 .34225 2604.1 190.79)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5156.8 1357.7c.033 11.732-.82 16.8-2.948 27.512 2.882 1.2 6.074.872 6.82-1.272 1.378-5.738.335-7.446-.342-12.49-1.37-4.342-.08-10.52-3.53-13.75zM5175.3 1333.9c-4.364 3.096-7.557 8.45-6.688 13.928.88 6.063 1.864 12.116 2.38 18.224 1.382 4.662 7.76 1.875 8.487-1.814 3.211-5.018 1.434-11.155.645-16.603-.934-4.486-.21-10.034-3.292-13.657l-.755-.206zM5195.1 1310.3c-4.3 3.166-7.386 8.527-6.538 13.981.863 6.048 1.83 12.086 2.302 18.181 1.352 4.668 7.722 1.829 8.39-1.855 2.652-4.129 1.886-9.323 1.06-13.88-.96-5.058-.862-10.338-2.653-15.217-.366-.973-1.56-1.637-2.561-1.21z",
    style: {
      fillRule: "evenodd",
      fill: "#cd242b",
      paintOrder: "markers fill stroke",
      stopColor: "#000",
      strokeDashoffset: 1.6197,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2.1783,
      stroke: "#000"
    },
    transform: "matrix(-.34604 -.01071 -.0106 .34225 2604.1 190.79)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5185.3 1322.1c-4.331 3.133-7.479 8.484-6.628 13.951.862 6.055 1.833 12.1 2.32 18.201 1.368 4.663 7.733 1.843 8.443-1.833 3.19-5.02 1.441-11.149.657-16.596-.929-4.481-.207-10.019-3.265-13.646l-.752-.205zM5204.5 1302.2c-4.368 3.272-7.207 8.991-5.95 14.468l3.416 18.725c2.22 4.135 7.375.06 8.01-3.218 2.375-4.591 1.245-9.968.063-14.73-1.453-4.91-.664-10.981-4.063-15.015l-.709-.26zM5283.9 1179.6c-4.079 3.678-6.09 9.798-4.139 15.058q2.879 9.32 5.582 18.693c2.087 3.853 6.887.207 7.265-2.986 2.146-4.685.69-10.005-1.013-14.583-1.876-4.91-2.543-10.263-5.074-14.918-.564-.834-1.582-1.463-2.621-1.265z",
    style: {
      fillRule: "evenodd",
      fill: "#cd242b",
      paintOrder: "markers fill stroke",
      stopColor: "#000",
      strokeDashoffset: 1.6197,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2.1783,
      stroke: "#000"
    },
    transform: "matrix(-.34604 -.01071 -.0106 .34225 2604.1 190.79)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5276.7 1192.1c-4.039 3.71-6.046 9.798-4.137 15.064q2.82 9.309 5.465 18.67c2.081 3.853 6.86.184 7.235-2.994 2.15-4.678.716-9.995-.965-14.578-1.847-4.904-2.487-10.245-4.995-14.896-.555-.833-1.567-1.475-2.603-1.266zM5291.5 1166.7c-4.099 3.663-6.144 9.789-4.174 15.053q2.926 9.33 5.683 18.71c2.01 3.803 6.847.403 7.22-2.802 2.265-4.706.827-10.143-.949-14.762-1.931-4.904-2.557-10.289-5.137-14.94-.572-.836-1.6-1.46-2.643-1.26zM5311.7 1147.7c.011 0 .057.062.066.071.063.2.135.398.196.6-2.246-1.366-3.783-.422-4.195 5.038-.496 6.564-.648 8.62 2.494 11.822-1.84-.922-3.065.248-3.584 4.225q-2.084-6.719-4.172-13.438c-1.82-4.778-.232-10.234 3.176-13.89 0 0 3.905 5.493 6.02 5.573zm-1.429 17.543s.041.042 0 0",
    style: {
      fillRule: "evenodd",
      fill: "#cd242b",
      paintOrder: "markers fill stroke",
      stopColor: "#000",
      strokeDashoffset: 1.6197,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2.1783,
      stroke: "#000"
    },
    transform: "matrix(-.34604 -.01071 -.0106 .34225 2604.1 190.79)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5299.9 1153.8c.76.129 1.457.642 1.891 1.27 2.468 4.373 3.136 9.426 4.863 14.087.025.063.048.133.073.196-.06.452-.177.68-.217 1.215-.482 6.382-.592 8.508 2.287 11.565q-.114.547-.282 1.087c-1.784-.635-3 .723-3.371 5.407-1.575.928-3.41.959-4.506-1.054-1.917-6.245-3.83-12.482-5.748-18.726-1.995-5.27.102-11.411 4.242-15.036a2.1 2.1 0 0 1 .768-.01zM5261.7 1218.4c-4.006 3.183-5.91 8.837-4.561 13.783 1.105 4.51 2.433 8.98 3.817 13.407.686 2.878.917 9.125 5.374 7.729 4.04-2.491 4.977-8.096 4.35-12.49-.791-4.66-2.78-9.01-3.774-13.625-1.15-3.024-1.264-8.235-5.206-8.804z",
    style: {
      fillRule: "evenodd",
      fill: "#cd242b",
      paintOrder: "markers fill stroke",
      stopColor: "#000",
      strokeDashoffset: 1.6197,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2.1783,
      stroke: "#000"
    },
    transform: "matrix(-.34604 -.01071 -.0106 .34225 2604.1 190.79)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5269 1205.4c-4.028 3.719-6.043 9.784-4.178 15.063l5.337 18.642c2.082 3.832 6.821.158 7.21-2.994 2.158-4.67.764-9.987-.89-14.58-1.819-4.894-2.422-10.219-4.893-14.867-.55-.832-1.557-1.464-2.586-1.264z",
    style: {
      fillRule: "evenodd",
      fill: "#cd242b",
      paintOrder: "markers fill stroke",
      stopColor: "#000",
      strokeDashoffset: 1.6197,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2.1783,
      stroke: "#000"
    },
    transform: "matrix(-.34604 -.01071 -.0106 .34225 2604.1 190.79)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      strokeWidth: 1.8888
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5422.7 1174.1c.017.045.036.078.053.124.975 2.614 6.045 16.876 6.778 18.922 1.473 4.115 1.428 5.637-.264 8.822-.25-.464-.51-.924-.794-1.34a1.07 1.07 0 0 0-.547-.06c-.543.089-1.058.58-1.398 1.216-.557 1.336-.998 2.749-1.4 4.19 1.603-5.496.333-12.129-2.45-16.206-.105-.043-.21-.034-.317-.039-.022-3.58-.338-5.422-1.694-7.723l.07-1.24c1.177.327 1.961-1.295 1.961-6.155v-.512zm2.41 31.958q-.266 1.066-.533 2.133c-.01 0-.016.01-.024.01q.264-1.08.558-2.143",
    style: {
      fillRule: "evenodd",
      fill: "#cd242b",
      paintOrder: "markers fill stroke",
      stopColor: "#000",
      strokeDashoffset: 1.6197,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 1.8888,
      stroke: "#000"
    },
    transform: "matrix(-.49138 -.01438 -.00938 .32059 3419.5 217.59)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5428.1 1158.2c.972.057 1.735 1.211 2.414 3.033.975 2.614 6.046 16.864 6.778 18.91 1.859 5.19 1.414 6.105-1.876 11.662-3.312 5.593-4.92 3.877-6.57-.636a3276 3276 0 0 1-6.098-17.027c.076-4.159.06-6.503-.515-8.443.517-1.09 1.239-2.335 2.215-3.982 1.501-2.536 2.68-3.573 3.652-3.516z",
    style: {
      fillRule: "evenodd",
      fill: "#cd242b",
      paintOrder: "markers fill stroke",
      stopColor: "#000",
      strokeDashoffset: 1.6197,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 1.8888,
      stroke: "#000"
    },
    transform: "matrix(-.49138 -.01438 -.00938 .32059 3419.5 217.59)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5443.1 1178.7c3.29-5.557 3.735-6.472 1.876-11.662-.732-2.045-5.796-16.306-6.77-18.92-1.36-3.643-3.067-4.585-6.07.487-2.912 4.918-3.812 6.39-2.508 10.168.78 2.26 6.004 16.83 6.903 19.29 1.65 4.514 3.257 6.231 6.569.638zM5456.7 1140.4c.186.427.357.87.548 1.292.967 2.524 2.341 4.556 3.925 5.915-.437 1.314-1.275 2.788-2.6 5.025-3.312 5.594-4.92 3.878-6.57-.636-.753-2.06-4.112-11.457-5.78-16.16.09-.04.182-.05.271-.098 0-.072-.01-.136-.012-.208.496.948 1.007 1.876 1.578 2.715 2.409 3.216 5.595 5.744 8.738 4.523.058-.808.01-1.598-.098-2.368z",
    style: {
      fillRule: "evenodd",
      fill: "#cd242b",
      paintOrder: "markers fill stroke",
      stopColor: "#000",
      strokeDashoffset: 1.6197,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 1.8888,
      stroke: "#000"
    },
    transform: "matrix(-.49138 -.01438 -.00938 .32059 3419.5 217.59)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5440.2 1135.1c1.937 1.224 4.03 1.653 6.036.734 1.236 3.367 5.802 16.203 6.505 18.166 1.86 5.19 1.414 6.105-1.876 11.662-3.312 5.593-4.92 3.865-6.57-.648-.9-2.46-6.125-17.021-6.906-19.281-1.304-3.78-.404-5.254 2.508-10.171.107-.18.2-.296.303-.462",
    style: {
      fillRule: "evenodd",
      fill: "#cd242b",
      paintOrder: "markers fill stroke",
      stopColor: "#000",
      strokeDashoffset: 1.6197,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 1.8888,
      stroke: "#000"
    },
    transform: "matrix(-.49138 -.01438 -.00938 .32059 3419.5 217.59)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M829.12 654.31c1.781.283 2.948 1.83 3.837 3.265.95 1.47 1.89 2.946 2.837 4.418-.766 1.375-2.53 1.86-3.999 1.561-1.595-.288-2.707-1.612-3.47-2.95-.724-1.548-2.017-2.709-2.84-4.184-.527-1.554 1.557-1.997 2.68-2.016q.477-.046.955-.094z",
    style: {
      fillRule: "evenodd",
      fill: "#cd242b",
      paintOrder: "markers fill stroke",
      stopColor: "#000",
      strokeDashoffset: 1.6197,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 0.75,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M823.76 655.72c2.03.714 2.96 2.799 4.092 4.45.732 1.093 1.415 2.218 2.11 3.335-1.27 1.232-3.26 1.74-4.928 1.079-1.519-.65-2.263-2.25-3.13-3.548-.676-1.477-2.216-2.557-2.508-4.164.811-1.29 2.655-1.253 3.995-1.23l.358.075zM835.07 653.05c1.781.282 2.952 1.825 3.839 3.263.95 1.473 1.889 2.953 2.834 4.43-.77 1.372-2.538 1.839-4.003 1.534-1.592-.293-2.702-1.615-3.465-2.951-.726-1.544-2.02-2.7-2.84-4.173-.517-1.552 1.563-1.985 2.682-2.008zM845.28 650.53q.353.001.68.059c.058.469.555.875.945 1.152 1.72 1.153 3.075 2.758 4.773 3.934.547.668 1.036 1.377 1.34 2.195-1.527 1.365-4.053 1.988-5.793.664-1.654-1.244-2.582-3.197-4.222-4.457-.933-.606-1.665-2.303-.317-2.89.833-.323 1.713-.52 2.594-.657z",
    style: {
      fillRule: "evenodd",
      fill: "#cd242b",
      paintOrder: "markers fill stroke",
      stopColor: "#000",
      strokeDashoffset: 1.6197,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 0.75,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M840.79 651.87a3.2 3.2 0 0 1 1.16.262c-.072.709.444 1.557 1.047 1.949 1.506 1.156 2.418 2.892 3.836 4.133.332.531.672 1.058.992 1.597-1.46 1.342-3.857 1.81-5.543.618-1.683-1.165-2.27-3.258-3.582-4.743-.573-.772-1.724-1.83-1.168-2.816.612-.785 1.713-.898 2.637-.95q.317-.059.621-.05zM848.81 648.49c.057.532.696.876 1.18 1.094 1.958.816 3.63 2.177 5.586 2.996.25.103.513.182.78.234h.005c.286.273.573.547.851.828.166.345.94.723.446 1.13-2.764 3.264-4.06 2.197-5.86.995-1.758-1.183-3.135-2.841-4.898-4.023-.548-.39-1.32-1.031-.77-1.75.455-.704 1.294-.99 2.036-1.278.209-.101.427-.173.644-.226zM791.23 659.84c2.093-.412 4.117.96 5.12 2.728 1.153 1.672 2.147 3.445 3.22 5.167.62.806-.194 1.572-.986 1.696-2.027.632-4.351-.32-5.404-2.152-1.092-1.635-2.047-3.357-3.132-4.997-.465-.576-1.155-1.942-.079-2.275.407-.141.84-.118 1.261-.167M784.33 660.14c1.836-.297 3.893.205 5.14 1.648 1.459 2.06 2.686 4.28 4.121 6.358.529.719.01 1.736-.9 1.67-1.944.576-4.23-.177-5.341-1.902-1.148-1.591-1.925-3.424-3.163-4.957-.704-.683-1.49-2.272-.233-2.804l.366-.013zM797.72 659.38c2.113-.348 4.021 1.196 4.957 2.976a716 716 0 0 1 3.382 5.33c-1.347 1.674-4.031 1.677-5.657.418-1.423-1.154-2.08-2.922-3.088-4.4-.718-1.074-1.469-2.133-2.04-3.296.277-1.064 1.598-.922 2.446-1.028M810.16 657.83c1.827-.325 3.382 1.015 4.299 2.456.994 1.56 2.055 3.083 2.984 4.682.221.527.622 1.223-.113 1.529-1.68 1.206-4.226.882-5.589-.659-1.329-1.457-1.99-3.388-3.318-4.85-.714-.773-1.495-2.453-.031-2.899.554-.232 1.177-.235 1.768-.259",
    style: {
      fillRule: "evenodd",
      fill: "#cd242b",
      paintOrder: "markers fill stroke",
      stopColor: "#000",
      strokeDashoffset: 1.6197,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 0.75,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M803.96 658.69c2.128-.336 3.946 1.325 4.868 3.088a175 175 0 0 1 3.193 5.113c-1.034 1.22-2.823 1.57-4.317 1.126-1.87-.56-2.817-2.398-3.71-3.976-.72-1.472-2.247-2.57-2.512-4.236-.04-1.117 1.74-.965 2.478-1.115zM817.38 656.79c2.163.455 3.163 2.619 4.306 4.267.75 1.216 1.653 2.418 2.176 3.728-1.245 1.391-3.488 1.768-5.108.808-1.77-1.04-2.475-3.088-3.613-4.684-.723-.924-2.298-2.386-1.18-3.542.982-.602 2.307-.591 3.419-.577M760.9 665.16c-.163.29-.39.57-.723.879-.086.08-.558.508-.75.683 1.165-1.03 1.944-1.042 2.051 1.313.047 1.026.063 1.707-.02 2.27q.332-.022.657-.082c.855.064 1.49-.87.976-1.598-.762-1.135-1.476-2.3-2.191-3.465zM761.05 660.23c-.085 0-.169.01-.254.012.224.282.365.832.406 1.738.067 1.468.107 2.277-.183 2.957.557.918 1.073 1.865 1.648 2.774 1.079 1.857 3.272 2.93 5.399 2.578 1.153.152 1.617-1.203.968-2.016-1.31-1.68-2.202-3.639-3.422-5.383-.931-1.595-2.726-2.612-4.562-2.66zM772.6 660.24c2.248-.209 4.501 1.08 5.499 3.099 1.11 1.661 2 3.463 3.193 5.07.442.573.546 1.752-.478 1.72-1.535.416-3.333.218-4.566-.85-1.486-1.29-2.248-3.168-3.293-4.794-.577-1.207-2.117-2.195-1.848-3.662.19-.656.974-.523 1.493-.583",
    style: {
      fillRule: "evenodd",
      fill: "#cd242b",
      paintOrder: "markers fill stroke",
      stopColor: "#000",
      strokeDashoffset: 1.6197,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 0.75,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M766.13 660.34a5.12 5.12 0 0 1 4.5 1.232c1.404 1.416 2.24 3.279 3.313 4.94.446 1.037 1.441 1.896 1.512 3.046-.249.975-1.584.7-2.355.782-2.15.02-3.834-1.54-4.764-3.356-.913-1.754-2.107-3.329-3.172-4.974-.415-.788-.106-1.862.966-1.67M778.73 660.21c1.919-.126 4.017.639 5.026 2.357 1.291 1.93 2.407 3.974 3.758 5.865.767.99-.555 1.983-1.53 1.768-1.866.287-3.849-.633-4.802-2.271-1.176-1.673-2.055-3.54-3.308-5.162-.549-.614-1.183-2.005-.137-2.457.324-.093.662-.068.993-.1zM850.95 646.18c.285.224.694.355 1.027.445 2.063.498 5.234 1.965 7.293 2.465q.435.104.801.086c.135.09.273.171.406.262.23.306 1.062.53.657 1.023-1.835 3.497-2.01 3.378-5.555 2.114-1.955-.819-3.627-2.18-5.586-2.997-.614-.276-1.494-.75-1.094-1.562.31-.779 1.078-1.227 1.75-1.652.096-.073.2-.124.301-.184z",
    style: {
      fillRule: "evenodd",
      fill: "#cd242b",
      paintOrder: "markers fill stroke",
      stopColor: "#000",
      strokeDashoffset: 1.6197,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 0.75,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M852.57 643.34c.102.018.207.042.3.055 1.999.21 5.15 1.147 7.145 1.36.431.044.794.01 1.106-.099.516.254 1.3.344 1.187 1.759-.452 2.209-.93 3.187-3.035 2.683-2.06-.5-5.23-1.967-7.293-2.464-.65-.176-1.592-.507-1.325-1.372.183-.818.573-1.268 1.17-1.793.131-.138.629-.021.745-.129",
    style: {
      fillRule: "evenodd",
      fill: "#cd242b",
      paintOrder: "markers fill stroke",
      stopColor: "#000",
      strokeDashoffset: 1.6197,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 0.75,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M852.49 640.21c.386.253.878.28 1.723.344 2.096.179 3.7.527 5.765.351.251-.111 1.342.03 1.922-.546.312.181.729 1.333.497 1.832-.167 1.974-.353 2.768-2.39 2.558-1.996-.213-5.148-1.15-7.145-1.36-.631-.083-1.557-.268-1.407-1.05.074-.714.545-1.618 1.035-2.129",
    style: {
      fillRule: "evenodd",
      fill: "#cd242b",
      paintOrder: "markers fill stroke",
      stopColor: "#000",
      strokeDashoffset: 1.6197,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 0.75,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M860.8 636.25c.757.401 1.19 1.205 1.477 3.055.037 1.797-1.94 1.45-2.29 1.605-2.065.175-3.67-.172-5.765-.351-1.534-.116-1.923-.083-2.574-1.575-.26-.478-.33-1.145-.317-1.785.498.405 1.008.347 2.059.262 2.098-.148 3.736-.057 5.75-.55.209-.135 1.128-.17 1.66-.661",
    style: {
      fillRule: "evenodd",
      fill: "#cd242b",
      paintOrder: "markers fill stroke",
      stopColor: "#000",
      strokeDashoffset: 1.6197,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 0.75,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M859.6 632.36c.612.37 1.075 1.12 1.55 2.61.317 1.769-1.69 1.734-2.01 1.94-2.015.494-3.653.404-5.75.552-1.534.123-1.916.215-2.79-1.157-.466-.611-.625-1.647-.652-2.472.689.693 1.16.583 2.414.367 2.076-.338 3.719-.393 5.68-1.067.19-.15 1.065-.265 1.558-.773",
    style: {
      fillRule: "evenodd",
      fill: "#cd242b",
      paintOrder: "markers fill stroke",
      stopColor: "#000",
      strokeDashoffset: 1.6197,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 0.75,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M858.79 629.12c.358.41.701 1.004 1.074 1.887.475 1.733-1.527 1.882-1.828 2.117-1.96.674-3.603.729-5.68 1.066-1.515.262-1.883.39-2.878-.898-.258-.28-.443-.674-.583-1.098.461.339.963.38 1.848-.024 1.779-.631 5.223-2.023 7.031-2.574.311-.071.702-.242 1.016-.477zM851.87 619.4c1.072.138 1.823 1.07 2.582 2.09.549.825-.57 1.539-1.262 1.726-1.68.59-5.19 2.435-6.84 3.098-1.47.744-1.812-.18-2.718-1.41-.252-.393-.497-.936-.532-1.418.416.289.877.32 1.606-.125 1.59-.794 4.938-2.918 6.566-3.64.186-.068.396-.18.598-.321",
    style: {
      fillRule: "evenodd",
      fill: "#cd242b",
      paintOrder: "markers fill stroke",
      stopColor: "#000",
      strokeDashoffset: 1.6197,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 0.75,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M857.44 625.41c.714.411 1.082 1.433 1.754 2.418.546.899-.673 1.608-1.414 1.777-1.808.552-5.253 1.943-7.031 2.575-1.593.724-1.953.053-3.043-1.313-.215-.26-.475-.627-.63-.988.462.265.968.252 1.798-.172 1.787-.728 5.237-2.31 7.058-2.957.593-.164 1.462-.69 1.508-1.34",
    style: {
      fillRule: "evenodd",
      fill: "#cd242b",
      paintOrder: "markers fill stroke",
      stopColor: "#000",
      strokeDashoffset: 1.6197,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 0.75,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M854.69 622.33c1.23-.016 1.67 1.307 2.602 2.54.601.888-.614 1.67-1.364 1.878-1.821.648-5.271 2.229-7.058 2.957-1.593.814-1.992.15-3.172-1.187-.48-.529-1.22-1.509-.629-2.004.326.124.718.083 1.277-.2 1.65-.663 5.16-2.508 6.84-3.097.43-.117 1.025-.439 1.281-.864.077-.01.152-.022.223-.024zM849.53 616.02c1.14-.01 1.692 1.273 2.56 2.262.615.778-.148 1.198-.822 1.441-1.628.723-4.975 2.846-6.566 3.64-1.406.86-1.821-.033-2.824-1.187a3.7 3.7 0 0 1-.575-1.094c.23-.05.483-.168.782-.39 1.476-.912 4.245-2.884 5.764-3.73.192-.09.411-.24.609-.414.273-.093.828-.526 1.072-.528",
    style: {
      fillRule: "evenodd",
      fill: "#cd242b",
      paintOrder: "markers fill stroke",
      stopColor: "#000",
      strokeDashoffset: 1.6197,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 0.75,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M846.12 613.5c.98.039 1.807.776 2.656 1.586.664.703-.296 1.58-.93 1.875-1.518.846-4.289 2.818-5.765 3.73-1.291.96-1.773.125-2.848-.91-.053-.058-.103-.137-.156-.203.044-.028.082-.04.129-.074 1.547-.902 4.24-3.36 5.828-4.191.63-.273 1.564-1.081 1.086-1.813z",
    style: {
      fillRule: "evenodd",
      fill: "#cd242b",
      paintOrder: "markers fill stroke",
      stopColor: "#000",
      strokeDashoffset: 1.6197,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 0.75,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M843.4 611.64c.994.086 1.814.88 2.652 1.75.659.759-.358 1.635-1.02 1.922-1.588.831-4.28 3.29-5.827 4.191-.266.187-.491.286-.7.344-.534-.336-.974-.595-1.886-1.234-.186-.149-.323-.334-.5-.489.277-.038.578-.18.937-.5 1.437-1.07 3.836-3.811 5.32-4.816.387-.222.877-.687 1.024-1.168",
    style: {
      fillRule: "evenodd",
      fill: "#cd242b",
      paintOrder: "markers fill stroke",
      stopColor: "#000",
      strokeDashoffset: 1.6197,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 0.75,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M840.31 609.34c1.012-.044 1.925.663 2.867 1.442.74.68-.168 1.667-.793 2.027-1.485 1.004-3.884 3.746-5.32 4.816-.359.32-.66.462-.938.5a16 16 0 0 1-1.53-1.496c1.32-1.262 3.35-4.125 4.69-5.254.55-.398 1.278-1.375.684-1.988q.172-.038.34-.047",
    style: {
      fillRule: "evenodd",
      fill: "#cd242b",
      paintOrder: "markers fill stroke",
      stopColor: "#000",
      strokeDashoffset: 1.6197,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 0.75,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M837.13 608.12c.908-.016 1.8.538 2.727 1.152.806.599.006 1.68-.579 2.102-1.341 1.129-3.37 3.991-4.69 5.254-.498-.57-.907-1.188-1.31-1.813 1.087-1.507 2.359-3.534 3.313-4.492.544-.472 1.25-1.619.395-2.144l-.075-.04q.11-.015.22-.02z",
    style: {
      fillRule: "evenodd",
      fill: "#cd242b",
      paintOrder: "markers fill stroke",
      stopColor: "#000",
      strokeDashoffset: 1.6197,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 0.75,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M834.51 607.25c.798.034 1.627.457 2.48.922.856.526.15 1.672-.394 2.144-.954.958-2.226 2.985-3.313 4.493a15.4 15.4 0 0 1-1.378-2.676c.571-.941 1.137-1.84 1.625-2.395.513-.505 1.144-1.693.257-2.164q-.141-.064-.28-.125.327-.152.663-.187.17-.019.34-.012z",
    style: {
      fillRule: "evenodd",
      fill: "#cd242b",
      paintOrder: "markers fill stroke",
      stopColor: "#000",
      strokeDashoffset: 1.6197,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 0.75,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M831.46 606.82c.739.043 1.522.383 2.328.758.887.47.256 1.658-.258 2.164-.487.555-1.053 1.454-1.625 2.394a15.6 15.6 0 0 1-1.093-5.265q.317-.07.648-.051z",
    style: {
      fillRule: "evenodd",
      fill: "#cd242b",
      paintOrder: "markers fill stroke",
      stopColor: "#000",
      strokeDashoffset: 1.6197,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 0.75,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      strokeWidth: 1.8888
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5426.6 1184.9c-.29 1.07-.618 1.988-1.313 3.012-.01.336-.01.587-.018.9 1.302-.586 1.96.959 2.015 6.098.075 7.127.32 9.152-2.126 12.439-.022.03-.17.212-.196.247 0 .142-.01.298-.01.45.82-.352 1.562-1.24 2.729-3.212 3.29-5.557 3.735-6.472 1.876-11.662l-2.958-8.272z",
    style: {
      fillRule: "evenodd",
      fill: "#cd242b",
      paintOrder: "markers fill stroke",
      stopColor: "#000",
      strokeDashoffset: 1.6197,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 1.8888,
      stroke: "#000"
    },
    transform: "matrix(.49138 -.01438 .00938 .32059 -1923.1 217.59)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5428.1 1158.2c-.364-.021-.767.164-1.193.47.037 4.67-.128 7.101-1.364 9.382v.293c-.01.544-.025.947-.035 1.436.963.094 1.546 1.842 1.591 6.188.046 4.414.073 6.91-.489 8.958.812 2.276 1.943 5.445 2.234 6.241 1.65 4.514 3.258 6.23 6.57.636 3.29-5.557 3.735-6.472 1.876-11.662-.732-2.045-5.795-16.295-6.77-18.909-.679-1.821-1.45-2.976-2.422-3.033z",
    style: {
      fillRule: "evenodd",
      fill: "#cd242b",
      paintOrder: "markers fill stroke",
      stopColor: "#000",
      strokeDashoffset: 1.6197,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 1.8888,
      stroke: "#000"
    },
    transform: "matrix(.49138 -.01438 .00938 .32059 -1923.1 217.59)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5443.1 1178.7c3.29-5.557 3.735-6.472 1.876-11.662-.732-2.045-5.796-16.306-6.77-18.92-1.36-3.643-3.067-4.585-6.07.487-2.912 4.918-3.812 6.39-2.508 10.168.78 2.26 6.004 16.83 6.903 19.29 1.65 4.514 3.257 6.231 6.569.638zM5457 1140.5c.105.763.155 1.545.098 2.344-3.143 1.221-6.33-1.307-8.738-4.523-.574-.843-1.087-1.774-1.585-2.727 0 .076.012.143.012.22-.162.084-.326.107-.489.173a3483 3483 0 0 0 5.713 15.974c1.65 4.513 3.258 6.23 6.57.636 1.37-2.313 2.22-3.81 2.643-5.158-1.478-1.355-2.769-3.284-3.684-5.672-.188-.415-.357-.848-.54-1.267z",
    style: {
      fillRule: "evenodd",
      fill: "#cd242b",
      paintOrder: "markers fill stroke",
      stopColor: "#000",
      strokeDashoffset: 1.6197,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 1.8888,
      stroke: "#000"
    },
    transform: "matrix(.49138 -.01438 .00938 .32059 -1923.1 217.59)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5440.2 1135.1c-.111.177-.212.302-.327.497-2.913 4.918-3.813 6.392-2.508 10.171.78 2.26 5.998 16.82 6.898 19.281 1.65 4.513 3.258 6.242 6.57.648 3.29-5.556 3.735-6.472 1.876-11.662-.696-1.943-5.136-14.45-6.43-17.98-2.028.833-4.14.343-6.079-.955",
    style: {
      fillRule: "evenodd",
      fill: "#cd242b",
      paintOrder: "markers fill stroke",
      stopColor: "#000",
      strokeDashoffset: 1.6197,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 1.8888,
      stroke: "#000"
    },
    transform: "matrix(.49138 -.01438 .00938 .32059 -1923.1 217.59)"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 748.88,
    cy: 707.87,
    r: 5.351,
    style: {
      InkscapeStroke: "none",
      fillRule: "evenodd",
      fill: "#cd242b",
      fontVariationSettings: "normal",
      paintOrder: "markers fill stroke",
      stopColor: "#000",
      strokeDashoffset: 1.6197,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 0.75,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M745.15 711.7c-3.606 1.989-4.9 7.082-4.9 13.105 0 .687.04 1.355.098 2.016 2.132-2.121 4.903-3.41 8.527-3.41 3.629 0 6.402 1.265 8.535 3.347.055-.64.094-1.288.094-1.953 0-6.026-1.29-11.123-4.9-13.114-.979.969-2.351 1.505-3.729 1.528-1.38-.024-2.746-.546-3.725-1.52",
    style: {
      fillRule: "evenodd",
      fill: "#cd242b",
      paintOrder: "markers fill stroke",
      stopColor: "#000",
      strokeDashoffset: 1.6197,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 0.75,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M748.87 723.41c-18.118 0-15.199 31.853-15.199 42.066h.117a15.199 3.965 0 0 1-.117-.234 15.199 3.965 0 0 1 15.199-3.965 15.199 3.965 0 0 1 15.098 3.527l.102-.008c0-10.214 2.918-41.387-15.2-41.387z",
    style: {
      InkscapeStroke: "none",
      fillRule: "evenodd",
      fill: "#cd242b",
      fontVariationSettings: "normal",
      paintOrder: "markers fill stroke",
      stopColor: "#000",
      strokeDashoffset: 1.6197,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 0.75,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 748.88,
    cy: 765.25,
    rx: 15.199,
    ry: 3.965,
    style: {
      InkscapeStroke: "none",
      fillRule: "evenodd",
      fill: "#cd242b",
      fontVariationSettings: "normal",
      paintOrder: "markers fill stroke",
      stopColor: "#000",
      strokeDashoffset: 1.6197,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 0.75,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M740.85 761.88c0-11.643.01-16.471 1.286-21.21M736.46 762.96c-.02-4.798-.287-13.046.308-17.214",
    style: {
      InkscapeStroke: "none",
      fill: "none",
      fontVariationSettings: "normal",
      paintOrder: "markers fill stroke",
      stopColor: "#000",
      strokeDashoffset: 1.6197,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 0.75,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M752.89 697.71a1 1 0 0 0-.105.014q-.104.092-.223.19c-.73.58-5.498 4.295-6.309 4.919-.27.208-.522.385-.752.523-.15.262-.2.484-.256.608.848-.913 2.27-1.425 3.625-1.45a5.35 5.35 0 0 1 4.72 2.845c.309-1.117.167-2.839.136-5.637-.016-1.474-.317-2.036-.836-2.012z",
    style: {
      fillRule: "evenodd",
      fill: "#cd242b",
      paintOrder: "markers fill stroke",
      stopColor: "#000",
      strokeDashoffset: 1.6197,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 0.75,
      stroke: "#000"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVa);
export default __webpack_public_path__ + "static/media/va.017240f025063d2f56bf6862fbbad409.svg";
export { ForwardRef as ReactComponent };